import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      theCompany: "The Company",
      products: "Products",
      contact_us: "Contact Us",
      agent_title: "Our AI agents are here to revolutionize how you work, think, and create.",
      agent_subtitle: "Whether you're looking to streamline processes, solve complex challenges, or innovate faster, we have the perfect solution for you.",
      privacy_policy: "Privacy policy",
      terms_use: "Terms of Use",
      legal: "Legal",
      contact: "Contact",
      help: "Help",
      published_by: "Published By: ",
      see_more: "See More",
      initialMessage1: "Hi! 👋",
      initialMessage2: "I'm Kamaleón. How can I help you today?",
      title: "Hi there! 👋",
      subtitle: "Start a chat. We're here to help you 24/7.",
      footer: "",
      getStarted: "New Conversation",
      inputPlaceholder: "Type your question..",
      closeButtonTooltip: "", sign_in: "Sign In",
      login: "Login",
      for_customer: "For Customer",
      for_authors: "For Authors",
      redirecting_to_app: "Redirecting to application...",
      video_not_supported: "Your browser does not support the video tag.",
      specific_solutions: "Looking for a specific solution?",
      help_you: "We can  help!",
      new_agents_discover: "Discover these new agents",
      new_solutions: "New solutions just for you!",
      discover_hero_title: "Specialized agents that work 24/7 for a fraction of the cost",
      discover_hero_subtitle: "You pay for value delivered: completed interactions and problems solved.",
      discover_step_1_title: "Choose your agents",
      discover_step_1_desc: "Select the agents your business needs",
      discover_step_2_title: "Integrate in minutes",
      discover_step_2_desc: "Connect with your existing tools",
      discover_step_3_title: "Scale without limits",
      discover_step_3_desc: "Pay for the interactions you consume",
      discover_agents_title: "Our agent",
      discover_agents_subtitle: "Meet your new elite team",
      discover_agents_tagline: "One specialized agent. One single goal: Multiply your productivity",
      solutions_you: "solutions just for you!",
      recommend_agents: "Recommended agents for you",
      find_interesting: "You might find this interesting",
      my_profile: "My Profile",
      discover_agents_option: "Discover Agents",
      my_agents: "My Agents",
      transactions: "Transactions",
      sign_out: "Sign Out",
      error_loading_agents: "There was a problem loading agents. Please try again.",
      add: "Add",
      uses: "Uses",
      earning: "Earning",
      recordedOn: "Recorded on",
      usedSince: "Used since",
      seeMore: "See more",
      go_back: "Go Back",
      privacy: {
        title: "Comprehensive Manual and Official Policy for the Protection of Personal Data",
        subtitle: "A single document integrating the Corporate Manual, the Data Protection Policy, the Privacy Notice, Procedures, Operational Guides, and the Compliance Plan, in accordance with the Organic Law on Personal Data Protection (LOPDP) and applicable Ecuadorian regulations.",
        s1_title: "1. Institutional Identification",
        s1_responsible: "Data Controller:",
        s1_responsible_value: "KRUGERCORPORATION S.A.S.",
        s1_type: "Type:",
        s1_type_value: "Simplified Stock Company",
        s2_title: "2. Purpose of the Document",
        s2_p1: "To establish the regulatory, organizational, and operational framework to guarantee the protection of personal data of its clients, workers, and third parties (suppliers), ensuring the effective protection of the rights of data subjects, informational self-determination, and information security, in strict compliance with the Organic Law on Personal Data Protection (LOPDP), its General Regulation, and the technical regulations issued by the Personal Data Protection Authority.",
        s2_p2: "This manual seeks to protect the fundamental rights and freedoms of data subjects by applying appropriate technical and organizational measures, with a focus on the protection of sensitive data.",
        s3_title: "3. Applicable Legal Framework",
        s3_intro: "The processing of personal data shall be governed by the following regulatory hierarchy:",
        s3_item1: "Constitution of the Republic of Ecuador",
        s3_item2: "Organic Law on Personal Data Protection and its Regulation",
        s3_item3: "Resolutions of the Superintendency of Personal Data Protection (SPDP)",
        s3_item4: "Organic Administrative Code (COA)",
        s3_item5: "Comprehensive Organic Criminal Code (COIP)",
        s4_title: "4. Scope of Application",
        s4_intro: "This document is mandatory and applies to all personal data processing carried out by KRUGERCORPORATION S.A.S., in physical and digital media, covering:",
        s4_material: "Material Scope:",
        s4_material_value: "All processing of personal data contained in any type of medium, whether physical or digital, automated or not.",
        s4_lifecycle: "Data Life Cycle:",
        s4_lifecycle_value: "From collection, registration, organization, conservation, to elimination, blocking, or anonymization of information.",
        s4_territory: "Territoriality:",
        s4_territory_value: "Activities carried out in Ecuadorian territory or those subject to national legislation by virtue of contracts.",
        s4_parties: "Interested Parties:",
        s4_parties_value: "Applies to relationships with clients, workers, and third parties (suppliers).",
        s5_title: "5. Definitions",
        s5_consent: "Consent:",
        s5_consent_value: "Free, specific, informed, and unequivocal expression of will, by which the data subject authorizes the data controller to process their personal data.",
        s5_personal_data: "Personal Data:",
        s5_personal_data_value: "Any data that identifies or makes identifiable a natural person, directly or indirectly.",
        s5_sensitive_data: "Sensitive Data:",
        s5_sensitive_data_value: "Data requiring special protection because its misuse can generate discrimination or violate fundamental rights. Includes: ethnicity, religion, health, biometric data (fingerprint, facial recognition), genetic data, sexual orientation, criminal record, among others.",
        s5_processor: "Data Processor:",
        s5_processor_value: "Natural or legal person, public or private, who alone or jointly processes personal data on behalf of the controller.",
        s5_controller: "Data Controller:",
        s5_controller_value: "Natural or legal person, public or private, who alone or with others decides on the purpose and processing of personal data.",
        s5_processing: "Processing:",
        s5_processing_value: "Any operation or set of operations performed on personal data, whether by automated, partially automated, or non-automated technical procedures, such as: collection, compilation, obtaining, registration, organization, structuring, conservation, custody, adaptation, modification, elimination, indexing, extraction, consultation, elaboration, use, possession, exploitation, distribution, transfer, communication or transmission, or any other form of enabling access, comparison, interconnection, limitation, suppression, destruction, and in general, any use of personal data.",
        s5_subject: "Data Subject:",
        s5_subject_value: "Natural person whose data is subject to processing.",
        s5_breach: "Security Breach:",
        s5_breach_value: "Security incident that affects the confidentiality, availability, or integrity of personal data.",
        s6_title: "6. Guiding Principles of Processing",
        s6_intro: "KRUGERCORPORATION S.A.S will strictly apply the following principles in all personal data processing:",
        s6_legality: "Legality:",
        s6_legality_value: "Data will be processed in strict compliance with the Constitution, the LOPDP, its Regulation, and other applicable regulations.",
        s6_loyalty: "Loyalty and Transparency:",
        s6_loyalty_value: "Processing will be fair and transparent. All information directed to data subjects will be easily accessible, easy to understand, and will use simple and clear language. Data will not be processed through illicit or unfair means.",
        s6_purpose: "Purpose:",
        s6_purpose_value: "Data will be collected for determined, explicit, and legitimate purposes. They will not be subsequently processed in a manner incompatible with those purposes, except for legal exceptions.",
        s6_minimization: "Relevance and Minimization:",
        s6_minimization_value: "Data collected will be relevant and limited to what is strictly necessary for the fulfillment of the purpose.",
        s6_proportionality: "Proportionality:",
        s6_proportionality_value: "Processing will be adequate, necessary, timely, relevant, and not excessive in relation to the purposes for which data was collected.",
        s6_security: "Security:",
        s6_security_value: "Adequate technical, physical, and organizational security measures will be implemented to protect data against risks, threats, or vulnerabilities.",
        s6_confidentiality: "Confidentiality:",
        s6_confidentiality_value: "Due secrecy and confidentiality will be guaranteed. Data will not be communicated to third parties for purposes other than those authorized, except by legal obligation. This confidentiality obligation remains even after the relationship with the company ends.",
        s6_quality: "Quality and Accuracy:",
        s6_quality_value: "Data must be accurate, complete, precise, and properly updated. The company will adopt measures to rectify or delete those that are inaccurate.",
        s6_conservation: "Conservation:",
        s6_conservation_value: "Data will be kept only for the time necessary to fulfill the purpose of processing. Once fulfilled, they will be deleted, blocked, or anonymized, unless there is a legal obligation to keep them.",
        s6_accountability: "Proactive and Demonstrated Accountability:",
        s6_accountability_value: "The company will demonstrate having implemented mechanisms for data protection and will be able to prove compliance with these principles before the Authority and data subjects. This includes data protection by design and by default.",
        s6_favorable: "Favorable Application to the Data Subject:",
        s6_favorable_value: "In case of doubt about the scope of a regulation, it will be interpreted and applied in the most favorable sense to the data subject.",
        s7_title: "7. Rights of Personal Data Subjects",
        s7_intro: "As a company, we know that the rights of personal data subjects for which we are responsible are those provided for in the Personal Data Protection Regime in the Republic of Ecuador, especially the following:",
        s7_right1: "i. Access their provided data that has been processed, free of charge;",
        s7_right2: "ii. Request the update and rectification of information regarding partial, inaccurate, incomplete, fragmented data, data that leads to error, or data whose processing is prohibited or unauthorized;",
        s7_right3: "iii. Request proof of the authorization granted;",
        s7_right4: "iv. File complaints for violations of current regulations;",
        s7_right5: "v. Revoke authorization and/or request data deletion, unless there is a legal or contractual duty that makes it imperative to keep the information;",
        s7_right6: "vi. Refrain from answering questions about sensitive data;",
        s7_right7: "vii. Request the modification, rectification, and/or elimination of information stored in KRUGER databases;",
        s7_right8: "viii. Request immediate access to their personal data;",
        s7_right9: "ix. Right to object;",
        s7_right10: "x. Right to data portability;",
        s7_right11: "xi. Right to suspension of processing;",
        s7_right12: "xii. Right to know what types of data the data controller holds.",
        s7_sensitive: "Regarding the processing of sensitive data, KRUGER guarantees that these will be subject at all times to confidentiality, protected against unauthorized or illicit processing, against damage or loss, as well as confidential secrecy in all cases, in accordance with the legal provisions enshrined in the Organic Law on Personal Data Protection.",
        s8_title: "8. Contact Channels and Response Time",
        s8_intro: "The company shall seek at all times to make KRUGER's Personal Data Processing Policy available to its clients and workers, in order to uphold and guarantee the constitutionally recognized rights related to personal data processing. The following channels have been defined for handling requests, petitions, inquiries, and/or complaints:",
        s8_channel1: "Email",
        s8_channel2: "Phone numbers",
        s8_channel3: "KRUGER offices located at Arizaga Luque N34-206 and Federico Paez, K+ Building, Batan Alto",
        s8_response: "KRUGER, through its Personal Data Protection Officer, will attend and respond to all inquiries, petitions, requests, or claims related to personal data within the time frame established by the Organic Law on Personal Data Protection. KRUGER will attend your requests in the shortest possible time, not exceeding the legal term of 15 business days and/or 30 days, depending on the type of request.",
        s9_title: "9. Obtaining Personal Data",
        s9_intro: "KRUGER obtains personal data from its clients and workers, including, when necessary, personal data of special or sensitive category, always in observance of the legal bases provided in the LOPDP and adopting enhanced security and confidentiality measures for their processing. Data is obtained directly from the data subject, through physical or electronic forms, service channels, contracts, communications, video surveillance recordings and calls, as well as from publicly accessible or legitimately authorized sources.",
        s9_general_title: "i. General identifying personal data",
        s9_general_content: "Names and surnames, ID number, tax identification number, nationality, landline and cell phone numbers, home address, email address, work address, cultural identity, date of birth, names and surnames of workers' spouses, marriage or common-law union date, worker's address, type of housing, place of birth, immigration status, occupation and hobbies, professional experience, academic data, transit and immigration data; information about legal proceedings; video images recorded through surveillance cameras; and telephone call records.",
        s9_special_title: "ii. Special Data",
        s9_special_intro: "The company processes different special categories of personal data:",
        s9_sensitive_data: "Sensitive Personal Data:",
        s9_sensitive_data_value: "such as health data, physical characteristics, ideological inclinations, sex, gender, height, weight, information about deceased family members, gender identity, sexual orientation, and geolocation data of personnel.",
        s9_biometric: "Biometric Data:",
        s9_biometric_value: "relating to the physical, physiological, or behavioral characteristics of our clients and staff, which provide unique information about their physiology or health. Includes voice recognition processes, image storage, signature collection, fingerprint code, and geolocation data.",
        s9_minors: "Minors' Data:",
        s9_minors_value: "relating to workers' children, such as number of children, age, and special medical conditions, processed exclusively with the express and verifiable consent of their parents or legal representatives.",
        s9_medical: "Medical Data:",
        s9_medical_value: "including catastrophic diseases, disabilities, health status, diagnoses, medical records, genetic data, mental health data, medical history, medical insurance, allergies, medications, blood type, treatments and medical procedures, exam results.",
        s9_labor: "Labor Data:",
        s9_labor_value: "position and company data, labor references, performance evaluations, worker aptitudes, as well as any other information necessary for the employment or contractual relationship.",
        s9_credit_title: "iii. Credit Data",
        s9_credit_content: "Property and financial data, identification and labor data, such as bank account number, personal credit data (information about assets, liabilities, capital), CIF code, supplier's tax address, account type, bank type, private and public insurance, salary, fees, commissions, expense projections, investments, property details, tax payment declarations and receipts, labor pensions, credits, and borrowing capacity.",
        s9_public_title: "iv. Public Data",
        s9_public_content: "Sentences and sanctions imposed by judicial authorities, prison orders, alimony, restraining orders, administrative or criminal complaints, criminal record certificate.",
        s10_title: "10. Roles and Responsibilities",
        s10_company_title: "10.1. The Company (General Management)",
        s10_company_intro: "Acts as Data Controller and its obligations are:",
        s10_company_proactive: "Proactive Accountability:",
        s10_company_proactive_value: "Accredit and demonstrate compliance with the principles and obligations of the LOPDP through verifiable policies, procedures, and security measures.",
        s10_company_decisions: "Decision Making:",
        s10_company_decisions_value: "Define the purposes and means of processing.",
        s10_company_resources: "Resource Management:",
        s10_company_resources_value: "Guarantee the allocation of economic, human, and technical resources necessary for implementing security measures.",
        s10_company_breach: "Breach Notification:",
        s10_company_breach_value: "Notify the Data Protection Authority and data subjects about security breaches within the established legal terms.",
        s10_dpo_title: "10.2. Data Protection Officer (DPO)",
        s10_dpo_intro: "The professional responsible for advising and supervising regulatory compliance:",
        s10_dpo_supervision: "Supervision and Advisory:",
        s10_dpo_supervision_value: "Inform and advise KRUGER on its legal obligations and supervise their compliance.",
        s10_dpo_contact: "Point of Contact:",
        s10_dpo_contact_value: "Act as liaison between KRUGER, the Data Protection Authority, and data subjects.",
        s10_dpo_independence: "Independence:",
        s10_dpo_independence_value: "Perform their duties with complete independence, without receiving instructions on how to carry out their tasks.",
        s10_dpo_confidentiality: "Confidentiality:",
        s10_dpo_confidentiality_value: "Maintain strict secrecy about information known in the exercise of their duties.",
        s10_staff_title: "10.3. Staff handling information",
        s10_staff_secrecy: "Confidentiality and Secrecy:",
        s10_staff_secrecy_value: "Keep secret the personal data to which they have access.",
        s10_staff_use: "Legitimate Use:",
        s10_staff_use_value: "Process data only for authorized purposes.",
        s10_staff_report: "Incident Reporting:",
        s10_staff_report_value: "Immediately notify the DPO of any suspected security breach.",
        s10_processor_title: "10.4. Data Processors (Suppliers)",
        s10_processor_contractual: "Contractual Compliance:",
        s10_processor_contractual_value: "Process data only following documented instructions and sign confidentiality and data protection clauses.",
        s10_processor_security: "Security Measures:",
        s10_processor_security_value: "Implement security measures equivalent to those of the company and guarantee the return or elimination of data at the end of the contract.",
        s11_title: "11. Limitation of Liability",
        s11_p1: "KRUGER shall not assume liability for direct or indirect damages arising from or related to the access or use of its web pages and digital media, even if it had prior knowledge of the possibility of such damages. This includes liability for damages caused by viruses that could infect clients' or users' computer systems.",
        s11_p2: "KRUGER, when collecting personal data, shall ensure that the data subject declares, through the mechanisms enabled to obtain their consent, that:",
        s11_declaration1: "i. They have been clearly and expressly informed about the processing to which their personal data will be subjected.",
        s11_declaration2: "ii. They know the purposes for which their data will be processed.",
        s11_declaration3: "iii. In case of sensitive data collection, they have the right to answer or not the questions asked and to decide whether or not to provide the requested information.",
        s11_declaration4: "iv. They know the rights they have as a personal data subject.",
        s11_declaration5: "v. They know the identification, physical or electronic address, and telephone number of KRUGER as the data controller.",
        s12_title: "12. Incident and Security Breach Management",
        s12_intro: "Every incident must be reported immediately, documented, evaluated, and corrected. In case of significant risk, the Superintendency of Personal Data Protection and the affected data subjects will be notified.",
        s12_detection_title: "12.1. Detection and Internal Registration",
        s12_detection1: "Any company member who detects a possible breach must report it immediately to the DPO.",
        s12_detection2: "If the breach occurs at a supplier, they are legally obligated to notify the DPO within a maximum of two (2) days.",
        s12_detection3: "The incident will be registered detailing: nature, date, compromised data, and probable consequences.",
        s12_risk_title: "12.2. Risk Assessment",
        s12_risk1: "The DPO and technical area will assess whether the breach constitutes a risk to the rights and freedoms of data subjects.",
        s12_risk2: "The volume of data, type of data, and cause will be determined.",
        s12_authority_title: "12.3. Notification to the Authority (Deadline: 5 days)",
        s12_authority_content: "If there is a risk, the Company will notify the Superintendency of Personal Data Protection and ARCOTEL as soon as possible, and no later than five (5) days. The notification will include: nature of the breach, categories of affected persons, measures adopted, and DPO contact.",
        s12_subjects_title: "12.4. Communication to Data Subjects (Deadline: 3 days)",
        s12_subjects_content: "If the breach entails a high risk to fundamental rights, affected persons will be communicated within three (3) days, in clear and simple language, explaining possible consequences and measures they can take to protect themselves.",
        s12_corrective_title: "12.5. Corrective and Containment Measures",
        s12_corrective1: "Immediate actions will be implemented to stop the incident.",
        s12_corrective2: "The incident and applied solutions will be documented to prevent repetition.",
        s13_title: "13. Data Transfers and Third-Party Relations",
        s13_p1: "KRUGER may transfer your personal data to third parties, both domestic and domiciled abroad, such as subsidiaries, related companies, service providers, and strategic allies with which it maintains a legal relationship.",
        s13_intro: "Transfers may be made to:",
        s13_item1: "Administrative authorities in the Republic of Ecuador and Ecuadorian and foreign financial authorities.",
        s13_item2: "Judicial authorities, Ecuadorian and foreign.",
        s13_item3: "Social Security institutions.",
        s13_item4: "Institutions, organizations, or sector entities for fraud prevention and risk assessment purposes.",
        s13_item5: "Service provider companies related to KRUGER's activities.",
        s13_item6: "Suppliers and contractors necessary for fulfilling the legal relationship with the data subject.",
        s13_sensitive: "KRUGER, when required to transfer sensitive personal data to third parties, will always obtain the express written consent of its clients and workers.",
        s14_title: "14. Worker and/or Collaborator Photo Update",
        s14_item1: "The Company will coordinate with each worker and/or collaborator the update of their photograph, which must be renewed every five (5) years.",
        s14_item2: "The worker and/or collaborator will be responsible for providing an updated photograph within the established period.",
        s14_item3: "The Company will be responsible for the custody and protection of updated photographs, guaranteeing adequate and secure processing of this information.",
        s15_title: "15. Purposes of Personal Data Processing",
        s15_clients_title: "15.1. Clients",
        s15_clients_item1: "Analysis of the supplier's ability to comply with the contract.",
        s15_clients_item2: "Management of the contractual relationship with the supplier.",
        s15_clients_item3: "Billing and payments for goods and/or services.",
        s15_clients_item4: "Coordination of product and/or service delivery.",
        s15_clients_item5: "Communication with the supplier.",
        s15_clients_item6: "Management of commercial benefits with the supplier.",
        s15_clients_item7: "Compliance with applicable legal and regulatory obligations.",
        s15_clients_item8: "Commercial activities related to the client or supplier relationship.",
        s15_clients_item9: "Implementation of projects related to the company's business.",
        s15_clients_item10: "Execution of what is established in the contract and applicable regulations.",
        s15_secondary_title: "15.2. Secondary Purposes",
        s15_secondary_item1: "Offering and promotion of goods, products, and services and/or commercial prospecting.",
        s15_secondary_item2: "Managing inter-institutional alliances.",
        s15_secondary_item3: "Marketing, advertising, commercial prospecting, evaluation of products and services.",
        s15_secondary_item4: "Contact for requests, complaints, and/or claims.",
        s15_secondary_item5: "Direct sales management of products or services offered by KRUGER.",
        s15_secondary_item6: "Surveys, studies, and/or personal data confirmation.",
        s15_secondary_item7: "Internal statistical analysis or sending news related to service improvements.",
        s15_secondary_item8: "Procedures before authorities in the Republic of Ecuador.",
        s15_secondary_item9: "Client and/or supplier service.",
        s15_secondary_item10: "Content personalization.",
        s15_secondary_item11: "Business model research and development.",
        s15_secondary_item12: "Collection management of amounts owed to the company.",
        s15_labor_title: "15.3. Labor Relations",
        s15_labor_item1: "Fulfillment of the employment contract.",
        s15_labor_item2: "Compliance with the company's legal obligations.",
        s15_labor_item3: "Compliance with the Labor Code and other applicable regulations.",
        s15_labor_item4: "Work management, planning, and organization, as well as promoting equality and safety in the workplace.",
        s15_labor_item5: "Human resources management and administration.",
        s15_labor_item6: "Compliance with occupational plans.",
        s15_labor_item7: "Application of corporate company policies.",
        s15_labor_item8: "Provision of health and safety measures at work.",
        s15_labor_item9: "Payment of profit-sharing benefits according to family dependents calculation.",
        s15_labor_item10: "Providing information to Ministry of Labor and Social Security Institute authorities.",
        s15_labor_item11: "Handling worker requests for labor references.",
        s15_labor_item12: "Use of video surveillance cameras in work spaces, exclusively for safeguarding health, safety, and protection of people and property.",
        s16_title: "16. Processing Time and Storage of Personal Data",
        s16_p1: "Personal data will be kept by KRUGER for the time strictly necessary to fulfill the purposes indicated in this Policy, or while there is a legal basis that justifies it, and/or until the data subject exercises their right of objection or revokes their consent.",
        s16_p2: "As a general rule, personal data will be stored on servers located in the Republic of Ecuador. Exceptionally, they may be stored outside Ecuadorian territory in the following jurisdictions: Peru, Colombia, Costa Rica, Panama, Nicaragua, Guatemala, El Salvador, United States, Spain, Bolivia, Mexico, and Uruguay.",
        s16_p3: "The company guarantees that personal data will not be stored indefinitely and that an annual review of its databases and servers will be carried out to properly segregate data and ensure secure and verified elimination processes.",
        s17_title: "17. Data Protection Impact Assessment (DPIA)",
        s17_p1: "In accordance with Article 42 of the LOPDP and Articles 29 to 32 of the General Regulation, KRUGER will carry out an Impact Assessment prior to the implementation of any new system or technology that implies a high risk to rights.",
        s17_mandatory: "Mandatory:",
        s17_mandatory_value: "This technical analysis will be mandatory when processing data of people with disabilities, health data, or psychological profiles on a massive scale.",
        s17_procedure: "Procedure:",
        s17_procedure_value: "The Data Protection Officer (DPO) will lead this analysis to identify risks and establish mitigating measures before starting the processing.",
        s18_title: "18. Personal Data Protection Policy",
        s18_content: "The company KRUGERCORPORATION S.A.S will act as the Data Controller for the Personal Data of its clients, workers, and third parties (suppliers), personal data that includes names, address, ID number, date of birth, health-related data, contact data such as home phone, cell phone, email, sensitive data, among others. KRUGER may process personal data of minors only with the express and verifiable consent of their parents or legal representatives, adopting enhanced security and confidentiality measures to protect this information.",
        s19_title: "19. Institutional Guarantees",
        s19_intro: "The company guarantees the application of the following principles and measures:",
        s19_confidentiality: "Confidentiality and Secrecy:",
        s19_confidentiality_value: "Data will not be disclosed to unauthorized third parties.",
        s19_security: "Information Security:",
        s19_security_value: "Technical and organizational measures are implemented to prevent loss, unauthorized access, or alteration of data.",
        s19_minimization: "Minimization and Conservation:",
        s19_minimization_value: "Only strictly necessary data will be collected and kept for the time required by regulations; once the term is met, secure deletion will proceed.",
        s20_title: "20. Privacy Notice",
        s20_responsible: "Controller and Purpose:",
        s20_responsible_value: "KRUGERCORPORATION S.A.S. will process the personal data provided for the management of information corresponding to internal procedures within the Company.",
        s20_legitimation: "Legitimation and Transfers:",
        s20_legitimation_value: "Processing is necessary for contractual execution and compliance with legal obligations. Strictly necessary data may be communicated to public control entities and authorized complementary service providers.",
        s20_conservation: "Conservation Time:",
        s20_conservation_value: "Information will be kept during the validity of the contractual obligation and subsequently during the legal periods required by the corresponding regulations for each procedure.",
        s20_rights: "Data Subject Rights:",
        s20_rights_value: "You may exercise your rights of access, rectification, deletion, objection, suspension, and portability.",
        s21_title: "21. Free and Informed Consent",
        s21_p1: "In compliance with the provisions of the Organic Law on Personal Data Protection, KRUGER informs that it will process the personal data you provide, in accordance with the purposes described in this Policy.",
        s21_p2: "KRUGER may collect or receive your data through its websites, forms, applications, devices, brand or product pages, social networks, or by any other physical or virtual means.",
        s21_p3: "By accepting this Policy, you grant your voluntary, free, prior, express, specific, informed, and unequivocal consent to KRUGER, its subsidiaries, affiliates, or related entities, as well as to third parties, contractors, and suppliers acting on its behalf, to carry out the processing, storage, destination, flow, and transfer, in any of its modalities, means, or media, whether local or cross-border, of the information and personal data you have provided through any means or modality.",
        s22_title: "22. Mechanisms and Procedures for Consent Revocation",
        s22_p1: "At all times, our clients and workers may revoke the consent they have granted to KRUGER for the processing of their personal data. However, it is important to note that not in all cases will we be able to fulfill such requests or conclude their use immediately, as it is possible that some legal obligation may require continued processing of your personal data.",
        s22_p2: "To request the revocation of consent, data subjects may go personally to KRUGER offices located at Arizaga Luque N34-206 and Federico Paez, K+ Building, Batan Alto; and/or send an email indicating their \"Consent Revocation Request\" accompanied by documents proving their identity.",
        s22_p3: "KRUGER must seek to attend to its clients' requests within the times stipulated in applicable laws, that is, between 15 and 30 days depending on the type of request.",
        s23_title: "23. Validity and Approval",
        s23_validity: "Validity:",
        s23_validity_value: "Takes effect from its subscription and dissemination.",
        s23_review: "Review:",
        s23_review_value: "It will be reviewed annually or when there are relevant regulatory changes by the Superintendency of Data Protection.",
      },
      edit_agent: "Edit Agent",
      Edit: "Edit",
      Delete: "Delete",
      "Are you sure you want to delete this description? This action cannot be undone.": "Are you sure you want to delete this description? This action cannot be undone.", confirmDelete: {
        title: "Confirm Delete",
        message: "Are you sure you want to delete this description? This action cannot be undone.",
        cancel: "Cancel",
        confirm: "Delete"
      },      agent_information: "Agent Information",
      default_agent_description: "No detailed description available for this section yet.",
      no_descriptions_available: "No descriptions available",
      mantra_details: "Create intelligent chatbots powered by your own knowledge. Upload documents, add URLs, and build a custom knowledge base that your chatbot uses to deliver accurate, contextual responses. Easily personalize its appearance, behavior, and tone, then embed it on your website or application with just a few clicks. Monitor usage, track conversations, and continuously improve your chatbot's performance — all from a single, intuitive dashboard.",
      acquire_agent_marketplace: "Buy now",
      acquired: "Acquired",
      expiredPlan:"Expired plan",
      freeAcquired: "Free plan acquired",
      upgradePlan:"Upgrade Plan",
      loading: "Loading...",
      processing_payment: "Processing payment...",
      error_purchasing_agent: "Error purchasing agent",
      agent_purchased_successfully: "Agent purchased successfully!",
      purchase_success: "Agent purchased successfully!",
      purchase_error: "Error purchasing agent",
      error_loading_purchase_state: "Error loading purchase state",
      filter_by_authors: "Filter by Authors",
      select_authors: "Select authors",
      search_authors: "Search authors...",
      clear_all: "Clear all",
      clear_search: "Clear search",
      apply_filter: "Apply filter",
      apply_filters: "Apply filters",
      clear_filters: "Clear filters",
      loading_authors: "Loading authors...",
      loading_more: "Loading more...",
      no_more_authors: "No more authors",
      no_authors_found: "No authors found",
      no_more_agents: "No more agents",
      no_agents_found: "No agents found.",
      my_purchased_agents_title: "My Purchased Agents",
      loading_text: "Loading...",
      error_loading_agents_purchased: "Error loading agents",
      error_loading_agents_retry: "Please try again later",
      loading_more_agents: "Loading more...",
      no_more_agents_purchased: "No more agents",
      no_purchased_agents_found: "No purchased agents found",
      no_purchased_agents_hint: "Try again later or buy an agent",
      plan_acquired: "Plan acquired",
      published_by_kaiman: "Published by KAIman",
      // Plan modal texts
      plan_modal: {
        title: "Select a plan",
        cta: "Pay now - {{price}}",
        per_month: "/month",
        opening_payment_gateway: "Opening payment gateway...",
        awaiting_payment: "Awaiting payment confirmation...",
        processing_payment: "Processing payment...",
        full_access: "Full access",
        plans: {
          Free: {
            title: "Free",
            subtitle: "Free",
            desc: "Free plan for testing",
            perks: ["Limited access", "Good for testing"]
          },
          Standard: {
            title: "Standard",
            subtitle: "Popular",
            desc: "All basic features",
            perks: ["Full access", "Basic support"]
          },
          Premium: {
            title: "Premium",
            subtitle: "Best value",
            desc: "All features, unlimited projects, priority support",
            perks: ["Full access", "Priority support", "Unlimited queries"]
          }
        }
      },
      terms_modal: {
        title: "Review and accept our Terms and Conditions",
        version_label: "Version {{version}}",
        default_content: "Please review the terms and conditions provided by KAIman.",
        accept_checkbox: "I have read and accept the terms and conditions.",
        accept_button: "Accept terms",
        success_message: "Terms and conditions accepted successfully.",
        error_message: "We couldn't process your acceptance. Please try again."
      },
      pricing_page: {
        title_prefix: "Choose how you want to",
        title_highlight: "scale with AI",
        subtitle: "Start with the essentials and evolve as your processes grow. Our agents adapt to your pace.",
        badge_refund: "30-day money-back guarantee",
        badge_support: "24/7 support",
        badge_cancel: "Cancel anytime",
        featured_badge: "BEST SELLER",
        month: "month",
        conversations: "Conversations",
        choose_plan: "Choose Plan",
        plan_selected: "Plan Selected",
        disclaimer: "All plans are prepaid. The monthly rate reflects the total plan price divided by the number of months included.",
        benefits_title: "Enjoy all of this at no additional cost",
        benefit_ssl: "Unlimited SSL security certificates",
        benefit_updates: "Automatic updates and backups",
        benefit_domain: "Free domain (with annual plans)",
        benefit_email: "Email addresses",
        benefit_templates: "Professionally designed templates",
        benefit_traffic: "Unlimited web traffic",
        compare_plans: "Compare Plans",
        compare_plans_title: "Compare our plans",
        compare_plans_subtitle: "Take a look at how much each plan costs and what you get for it.",
      },
      plan_units: {
        whatsapp: "Use of Whatsapp with the chatbot",
        leads: "Leads validation and list",
        webhooks: "Real-time leads webhooks",
        chatbot: "{{count}} Chatbot",
        chatbots: "{{count}} Chatbots",
        conversation: "{{count}} conversation per month",
        conversations: "{{count}} conversations per month",
        knowledge_source: "Up to {{count}} reference website",
        knowledge_sources: "Up to {{count}} reference websites",
        knowledge_file: "Up to {{count}} file",
        knowledge_files: "Up to {{count}} files",
        knowledge_file_size: "Up to {{count}} MB per file",
        ai_basic: "Basic AI model",
        ai_standard: "Standard AI model",
        ai_advanced: "Advanced AI model"
      },
      agent_relations_modal: {
        acquire_agent: "Acquire Agent",
        select_plan: "Select a plan"
      },
      agent_terms: {
        accept_label: "I accept the",
        terms_link: "terms and conditions",
        modal_title: "Terms and Conditions"
      },
      active_filters: "Active filters",
      filter_by_states: "Filter by States",
      select_states: "Select states",
      search_states: "Search states...",
      no_states_found: "No states found",
      active_state_filters: "Active state filters",
      name_or_summary: "Name or Summary",
      search_name_summary: "Search by name or summary...",
      registered_by_me: "Registered by me",
      search: "Search",
      reset_filters: "Reset filters",
      no_results_found: "No results found",
      error_loading_results: "Error loading results",
      // ApiDefinitionForm keys
      api_error_message: "An error occurred while communicating with the API. Please try again later.",
      api_creating_message: "The automatic API configuration is being performed, please wait...",
      api_updating_message: "The automatic API configuration is being updated, please wait...",
      download_swagger_label: "Download Swagger",
      swagger_file_description: "Download the current Swagger/OpenAPI definition file for this API.",
      download_swagger_short: "Download",
      alias: "Alias",
      alias_error: "No special characters allowed: ~!@#;:%^()+={}|\\<>\"',&$[]/",
      alias_placeholder: "E.g.: api-my-service",
      alias_help: "Unique API name in WSO2. Max 50 characters.",
      alias_tooltip: "Name to be given to the API in WSO2. This name is unique and cannot be changed.\n<b>Example:</b> <span class='text-blue-500'>my-service-api</span>",
      domain: "Domain",
      domain_placeholder: "E.g.: https://api.example.com/services",
      api_to_get_plans_of_application: "Api to get plans of application",
      api_to_create_subscription: "Api to create subscription",
      api_to_webhook_subscription: "Api to webhook subscription",
      domain_help: "Base domain for web services. Max 232 characters.",
      domain_tooltip: "Domain where the web services are hosted. It is the common part of your endpoints URLs.<br/><b>Example:</b> <span class='text-blue-500'>https://api.example.com/services</span><br/><ul class='list-disc pl-4 mt-1'><li>https://api.example.com/services/persons <span class='text-gray-400'>(GET)</span></li><li>https://api.example.com/services/persons/{id} <span class='text-gray-400'>(DELETE)</span></li><li>https://api.example.com/services/persons/{id} <span class='text-gray-400'>(PUT)</span></li></ul>The domain would be: <b>https://api.example.com/services</b>",
      auth_type: "Authentication Type",
      oauth2: "OAuth2",
      basic: "Basic",
      apikey: "Apikey",
      auth_type_help: "Select the required authentication type.",
      duration: "Duration",
      minutes: "Minutes",
      hours: "Hours",
      days: "Days",
      apikey_time_help: "API Key expiration time.",
      swagger_label: "JSON swagger",
      browse: "Browse",
      or_drag: "or drag & drop here",
      swagger_help: "Upload the swagger file for the web services.",
      selected_file: "Selected file: {{name}}",
      // Download Swagger section
      // Download Swagger section
      cancel: "Cancel",
      continue: "Continue",
      confirm_title: "Are you sure you want to save the configuration?",
      confirm_text_create: "Creating this configuration may affect the behavior of the API. Are you sure you want to continue?",
      confirm_text_update: "Modifying the configuration parameters may cause the previous behavior of the API to change. Are you sure you want to continue?",
      confirm: "Confirm",
      update: "Update",
      relation_tab: {
        saving: "Saving changes...",
        saved: "Changes saved!",
        loading: "Loading related agents...",
        no_agents: "No related agents",
        name: "Name",
        summary: "Summary",
        relation: "Relation",
        obligatory: "Obligatory",
        actions: "Actions",
        yes: "Yes",
        no: "No",
        agent_already_added: "This agent is already added with this relation",
        agent_added: "Agent added successfully",
        saving_relation: "Saving relation...",
        error_adding_agent: "Error adding agent",
        error_updating: "Error updating relation",
        error_updating_relation: "Error updating agent relation",
        deleting: "Deleting relation...",
        deleted: "Relation deleted successfully",
        error_deleting: "Error deleting relation",
        error_deleting_relation: "Error deleting agent relation",
        modal_title: "Agent Relations",
        modal_select: "Select",
        modal_no_relations: "No related agents found",
        modal_loading: "Loading related agents...",
       
      },
       my_purchased_agents: "My Purchased Agents",
       my_purchased_agents_page: {
        title: "My Purchased Agents",
        loading: "Loading...",
        error_loading: "Error loading agents",
        try_again_later: "Please try again later",
        loading_more: "Loading more...",
        no_more_agents: "No more agents",
        no_agents_found: "No purchased agents found",
        try_later_or_buy: "Try again later or purchase an agent",
       },
       agent_dashboard: {
        title: "Agent Administration",
        stats_tab: "Statistics",
        users_tab: "Users",
        invoices_tab: "Invoices",
        add_user: "Add User",
        download_code: "Download Code",
        go_to_dashboard: "Go to Dashboard",
        go_to_app: "Go to App",
        download_modal: {
          title: "Download Code",
          subtitle: "Interview agent HTML demo",
          api_key_required: "Important: API Key Required",
          api_key_points: {
            point1: "You will need an API Key to use the agent",
            point2: "Create a user first to get your API Key",
            point3: "The downloaded HTML includes a field to enter the API Key",
            point4: "This is just a demonstration of how it would be integrated"
          },
          what_includes: "What does the file include?",
          what_includes_desc: "Fully functional HTML with agent simulation, integrated styles and integration example.",
          cancel: "Cancel",
          download_now: "Download Now"
        },
        carousel: {
          welcome_title: "We will take you from zero to having a functional agent in a few steps",
          welcome_description: "With the purchase already completed, the next step is to create a user. This way you will get your API Key, essential to get started.",
          welcome_bubble: "Hello Welcome",
          ready_title: "Now that you have the API Key",
          ready_description: "Enter the API Key where we request it and you can download a code example",
          ready_bubble: "Almost ready!",
          done_title: "Ready we already generated the code",
          done_description: "Now you can download it to be able to use it",
          done_bubble: "you can use it now",
          download_button: "Download the code here"
        },
        stats_title: "Agent Statistics",
        stats_desc: "Usage statistics for each user.",
        bar_chart: "Bar Chart",
        pie_chart: "Pie Chart",
        loading_stats: "Loading statistics...",
        loading_wait: "Please wait a moment",
        loading_table: "Loading table data...",
        error_title: "Error Loading Data",
        error_desc: "There was a problem loading the statistics. Please try again later.",
        error_table: "Error loading table data. Please try again.",
        no_data: "No data available",
        no_results: "No results found for your search",
        no_chart_data_title: "No Statistics Available",
        no_chart_data_desc: "There are no usage statistics to display for this agent yet.",
        search_placeholder: "Search by name, email or username...",
        search_button: "Search",
        page: "Page",
        previous: "Previous",
        next: "Next",
        table_api_name: "API Name",
        table_user_name: "User Name",
        table_name: "Name",
        table_email: "Email",
        table_usage: "Usage",
      },
      users_crud_table: {
        api_key: "API Key",
        api_key_hidden: "Hidden",
        api_key_placeholder: "API Key",
        toast_user_created: "User created successfully!",
        toast_user_updated: "User updated successfully!",
        toast_user_deleted: "User deleted successfully!",
        alert_api_key_title: "This is your API Key",
        alert_api_key_desc: "Save this API Key securely. You won't be able to see it again.",
        alert_api_key_copy: "Copy",
        alert_api_key_copied: "Copied!",
        alert_api_key_save_message: "Make sure to save your API Key. You will need it to access the API.",
        alert_api_key_accept: "Accept",
        title: "Users",
        create_user: "Create User",
        edit_user: "Edit User",
        no_users: "No users",
        page: "Page",
        of: "of",
        first_name: "First Name",
        last_name: "Last Name",
        name: "Name",
        surname: "Surname",
        email: "Email",
        email_address: "Email Address",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        confirm_delete_title: "Delete user?",
        confirm_delete_desc: "Are you sure you want to delete this user?",
        confirm_delete: "Delete",
        placeholder_name: "Name",
        placeholder_surname: "Surname",
        placeholder_email: "Email",
        placeholder_email_full: "user@company.com",
        previous: "Previous",
        next: "Next",
        search_placeholder: "Search by name, surname or email...",
        search_button: "Search",
        security_notice: "Security Notice",
        security_notice_desc: "An API key will be generated automatically. Store it securely as it won't be shown again.",
        generate_credentials: "Generate API credentials for agent access",
        done: "Done",
        api_key_generated: "API Key Generated Successfully",
        api_key_ready: "Your authentication credentials are ready",
        generated_api_key: "Generated API Key",
      },
      // Purchase Success Modal
      purchase_success_modal: {
        title: "Purchase Completed Successfully",
        thank_you: "Thank you for acquiring",
        default_agent: "AI Interviewer",
        subtitle: "Get ready to transform your interviews!",
        benefits: {
          immediate_access: "Immediate access to the agent and its capabilities.",
          priority_support: "Priority support according to the chosen plan.",
          subscription_management: "Subscription and billing management in your panel."
        },
        close: "Close",
        view_invoice: "View Invoice",
        start_using: "Start Using the Agent"
      },
      invoices: {
        page_title: "My Subscription",
        page_subtitle: "Manage and download all your purchase invoices",
        list: {
          billing_loading: "Validating billing details...",
          billing_error_title: "We couldn't validate your billing details",
          billing_error_subtitle: "Try again in a few seconds",
          billing_retry: "Retry",
          billing_missing_title: "Complete your billing information",
          billing_missing_description:
            "To download and print invoices we first need your tax information.",
          billing_missing_button: "Enter billing information",
          fetch_loading: "Loading invoices...",
          fetch_error_title: "Error loading invoices",
          fetch_error_subtitle: "Please try again later",
          fetch_retry: "Retry",
          empty_title: "No invoices found",
          empty_subtitle: "Invoices will appear here after you make purchases",
          title: "My Invoices",
          refresh: "Refresh",
          manage_billing: "Billing data",
          table: {
            date: "Date",
            amount: "Amount",
            status: "Status",
            actions: "Actions",
          },
        },
        billing_data: {
          form_title_create: "Enter billing information",
          form_title_edit: "Edit billing information",
          form_subtitle:
            "Complete your tax information to access invoice downloads",
          type_client: "Client type",
          type_client_person: "Individual",
          type_client_company: "Company",
          document_type: "Document type",
          document_number: "Document number",
          company_name: "Company name",
          names: "Names",
          surnames: "Surnames",
          mail: "Email",
          phone: "Phone",
          address: "Address",
          submit: "Save",
          cancel: "Back",
          saving: "Saving...",
          success_create: "Billing data saved successfully",
          success_update: "Billing data updated successfully",
          error_submit: "We couldn't save your billing data. Try again.",
          loading: "Loading billing data...",
          validation_names_required: "Names are required",
          validation_surnames_required: "Surnames are required",
          validation_company_required: "Company name is required",
          validation_document_invalid: "Invalid document number",
          validation_phone_invalid: "Only numbers are allowed",
          validation_address_invalid: "Maximum 250 characters",
          description: "Some fields change depending on the client type.",
          goto_invoices: "Back to invoices",
        },
      },
      invoice: {
        billing_data_error: "We couldn't validate your billing details",
        billing_data_retry: "Retry",
        download: "Download invoice",
        view_details: "View details",
        status: {
          completed: "Completed",
          success: "Successful",
          pending: "Pending",
          failed: "Failed"
        },
        details: {
          title: "Invoice Details",
          payment_id: "Payment ID",
          amount: "Amount",
          date: "Date",
          status: "Status",
          download: "Download Invoice",
          close: "Close"
        }
      },
      terms_of_use: {
        last_updated: "Last updated: March 2026",
        section1_title: "Acceptance of Terms",
        section2_title: "Description of Service",
        section3_title: "Acceptable Use",
        section4_title: "Intellectual Property",
        section5_title: "Privacy and Personal Data",
        section6_title: "Limitation of Liability",
        section7_title: "Modifications",
        section8_title: "Contact"
      },
      subscription: {
        free_plan_already_claimed: "You have already claimed the free plan",
        next_billing: {
          locale: "en-US",
          unavailable: "Not available",
        },
        status: {
          unknown: "Unknown",
          active: "Active",
          pending_cancel: "Pending cancellation",
          cancelled: "Cancelled",
          label: "Status",
        },
        view_invoices: "My subscription",
        reactivate: "Reactivate",
        reactivate_success: "Subscription reactivated successfully",
        reactivate_error: "Error reactivating subscription",
        grace_period: {
          title: "Access until end of period",
          message: "You can continue using the agent until",
        },
        cancel_success: "Your subscription was cancelled successfully",
        cancel_error: "There was an error cancelling your subscription",
        cancel_missing_client: "We couldn't identify the subscription to cancel",
        cancel_reason_required: "Select or enter a reason",
        cancel_reason: {
          too_expensive: "Too expensive",
          not_using: "I don't use it frequently",
          missing_features: "I need additional features",
          alternative: "I found a better alternative",
          other: "Other",
        },
        details: {
          title: "Your subscription details",
          subtitle: "Check your plan status and manage the subscription",
          agent_missing: "Select an agent to view its subscription",
          no_agent_selected:
            "Visit the purchased agents page and open the subscription of the agent you want to review.",
          error_loading:
            "We couldn't retrieve your subscription information. Please try again later.",
          no_subscription: "We couldn't find an active subscription for this agent.",
          plan: "Current plan",
          free_plan: "Free plan",
          unnamed_plan: "Custom plan",
          status: "Status",
          next_renewal: "Next renewal",
          cancel_at_period_end: "The subscription will end at the end of the current period",
          expired: "Your subscription period has ended",
          manage_message:
            "You can cancel your plan anytime. Your access will remain until the end of the billed period.",
          cancelling: "Cancelling...",
          cancel_button: "Cancel subscription",
          refresh_invoices: "Refresh invoices",
        },
        cancel_modal: {
          title: "Cancel subscription",
          description:
            "Tell us why you want to cancel. This information helps us improve.",
          question: "What is the main reason for cancelling?",
          other_placeholder: "Tell us a bit more",
          other_input_placeholder: "Write your reason here",
          keep: "Keep subscription",
          confirming: "Confirming...",
          confirm: "Confirm cancellation",
        },
      },
      // Landing page marketing
      landing: {
        hero_title: "AI Agents that work for you while you scale",
        hero_title_pre1: "AI Agents that",
        hero_title_hl1: "work",
        hero_title_pre2: "for you while you",
        hero_title_hl2: "scale",
        hero_subtitle: "Multiply your team's productivity with specialized agents that resolve, analyze, estimate, and scale.",
        hero_cta: "Request Demo",
        metrics: {
          interactions: "Interactions processed",
          companies: "Active companies",
          uptime: "Guaranteed uptime",
          satisfaction: "Customer satisfaction"
        },
        pain_title: "Your team is burning time on tasks that AI can do better",
        pain_title_pre: "Your team",
        pain_title_hl: "is burning time",
        pain_title_post: "on tasks that AI can do better",
        pain_subtitle: "While your competition automates, you keep paying man-hours for repetitive work.",
        pain_1_title: "72% of time lost",
        pain_1_subtitle: "on administrative and repetitive tasks that generate no value.",
        pain_2_title: "Unresolved tickets",
        pain_2_subtitle: "piling up because your support team is overwhelmed.",
        pain_3_title: "Projects derailed",
        pain_3_subtitle: "by inaccurate estimates that destroy margins.",
        steps_title: "Specialized agents that work 24/7 for a fraction of the cost",
        steps_title_pre: "Specialized agents that work",
        steps_title_hl: "24/7",
        steps_title_post: "for a fraction of the cost",
        steps_subtitle: "You pay for value delivered: completed interactions and problems solved.",
        step_1_title: "Choose your agents",
        step_1_desc: "Select the agents your business needs",
        step_2_title: "Integrate in minutes",
        step_2_desc: "Connect with your existing tools",
        step_3_title: "Scale without limits",
        step_3_desc: "Pay for the interactions you consume",
        agents_title: "Our Agent",
        agents_subtitle: "Meet your new elite team",
        agents_desc: "One specialized agent. One single goal: Multiply your productivity",
        resolve: {
          name: "KAIMAN CX Agent",
          tagline: "Support that resolves. No excuses.",
          metric: "85% of tickets resolved automatically",
          description: "Your front-line shield for technical support and customer service. Resolves tickets in seconds, not days.",
          feature_1: "Automatic ticket resolution",
          feature_2: "Intelligent escalation",
          feature_3: "24/7 contextual responses",
          feature_4: "CRM integration",
          cta: "Try CX Agent"
        },
        talent_scout: {
          name: "KAIMAN TALENTIA",
          tagline: "Find diamonds. Discard stones.",
          metric: "70% reduction in hiring time",
          description: "Your tireless headhunter that analyzes CVs, evaluates candidates, and predicts cultural fit with surgical precision.",
          feature_1: "Automatic CV screening",
          feature_2: "Competency evaluation",
          feature_3: "Turnover prediction",
          feature_4: "AI cultural match",
          cta: "Try Talentia"
        },
        sprint: {
          name: "KAIMAN SCRIPTIA",
          tagline: "Perfect User Stories. Successful Sprints.",
          metric: "3x faster refinement",
          description: "Accelerate your SDLC with flawless user stories. Structure, acceptance criteria, and estimates in seconds.",
          feature_1: "User Story generation",
          feature_2: "Automatic acceptance criteria",
          feature_3: "Jira/Azure DevOps integration",
          feature_4: "Intelligent estimation",
          cta: "Try Scriptia"
        },
        forecast: {
          name: "KAIMAN QUANTIA",
          tagline: "Budgets that hold. Projects that deliver.",
          metric: "92% accuracy in estimates",
          description: "The estimation architect that eliminates uncertainty. Predictions based on historical data and real complexity.",
          feature_1: "History-based estimates",
          feature_2: "Technical complexity analysis",
          feature_3: "Automatic roadmaps",
          feature_4: "Deviation alerts",
          cta: "Try Quantia"
        },
        read_more: "Read more",
        final_cta_title: "Ready to multiply your team's productivity?",
        final_cta_subtitle: "Join the 500+ companies already scaling with KAIMAN.",
        final_cta_button: "Start free today"
      },
      agent_form: {
        required: "(Required)",
        required_max_chars: "(Required, max {{max}} characters)",
        min_max_range: "(Min: {{min}}, Max: {{max}})",
        close: "Close",
        go_back: "Go back",
        updating: "Updating...",
        creating: "Creating...",
        saving: "Saving...",
        deleting_dots: "Deleting...",
        edit_agent: "Edit Agent",
        add_agent: "Add Agent",
        agent_section: "Agent",
        name_label: "Name*",
        name_placeholder: "Agent name",
        description_label: "Description*",
        description_placeholder: "Agent description",
        description_required: "Description is required",
        description_max_length: "Description cannot exceed 130 characters",
        agent_type: "Agent Type",
        application: "Application",
        logo_label: "Logo*",
        using_defaults: "Using defaults",
        loading_settings: "Loading settings...",
        error_loading_settings: "Error loading file settings. Using default values.",
        logo_preview: "Logo Preview",
        loading_file_settings: "Loading file settings...",
        using_default_settings: "Using default settings",
        invalid_file_type: "Invalid file type. Allowed types: {{types}}",
        file_too_large: "File is too large. Maximum size is {{size}}",
        labels_label: "Labels*",
        max_labels_reached: "Maximum labels reached",
        search_create_labels: "Search or create new labels...",
        searching_labels: "Searching labels...",
        creating_label: "Creating \"{{term}}\"...",
        create_label: "Create \"{{term}}\"",
        no_labels_found: "No labels found",
        max_labels_limit: "Maximum labels limit reached",
        max_labels_desc: "You can only add up to {{max}} labels per agent.",
        min_labels_required: "Minimum labels required",
        min_labels_desc: "You need at least {{min}} label(s) per agent.",
        max_labels_exceeded: "Maximum labels exceeded",
        description_too_long: "Description too long",
        description_too_long_desc: "Description cannot exceed {{max}} characters. Current: {{current}}",
        about_too_long: "About too long",
        about_too_long_desc: "About cannot exceed {{max}} characters. Current: {{current}}",
        country: "Country:",
        select_country: "Select country",
        no_countries_available: "No countries available",
        state_province: "State / Province*",
        select_state: "Select state",
        select_country_first: "Select a country first",
        city: "City*",
        select_city: "Select city",
        select_state_first: "Select a state first",
        principal_street: "Principal Street*",
        number: "Number*",
        secondary_street: "Secondary Street*",
        zip_code: "ZIP code*",
        reference: "Reference:",
        failed_load_countries: "Failed to load countries",
        error_loading_countries: "There was an error loading the countries list. Please try again.",
        failed_load_states: "Failed to load states",
        error_loading_states: "There was an error loading the states list. Please try again.",
        failed_load_cities: "Failed to load cities",
        error_loading_cities: "There was an error loading the cities list. Please try again.",
        agent_updated: "Agent has been updated",
        agent_updated_desc: "Your agent has been updated successfully.",
        failed_update_agent: "Failed to update agent",
        error_updating_agent: "There was an error updating your agent. Please try again.",
        agent_created: "Agent has been created",
        agent_created_desc: "Your agent has been created successfully and is now available.",
        failed_create_agent: "Failed to create agent",
        error_creating_agent: "There was an error creating your agent. Please try again.",
        author_section: "Author",
        brand_name: "Brand name*",
        brand_name_placeholder: "Brand name",
        full_name: "Full name*",
        full_name_placeholder: "Full name",
        about_label: "About*",
        about_placeholder: "About the author",
        about_required: "About is required",
        about_max_length: "About cannot exceed 130 characters",
        edit_tab: "Edit {{tab}}",
        add_tab: "Add {{tab}}",
        edit_description: "Edit Description",
        add_description: "Add Description",
        media_label: "Media:",
        details_label: "Details:",
        description_is_required: "Description is required",
        image_is_required: "Image is required",
        or_drag_file: "or drag a file here",
        description_updated: "Description has been updated",
        description_updated_desc: "Your description has been updated successfully.",
        description_created: "Description has been created",
        description_created_desc: "Your description has been created successfully and is now available.",
        failed_create_description: "Failed to create description",
        error_creating_description: "There was an error creating your description. Please try again.",
        search_agent: "Search agent...",
        select_relation: "Select relation",
        select_relation_first: "Select a relation type first",
        add_button: "Add",
        delete_relation_title: "Delete relation",
        delete_relation_desc: "Are you sure you want to delete this agent's relation?",
        delete_button: "Delete",
      },
      plan_stepper: {
        trial_label: "Trial",
        trial_price: "Free",
        trial_duration: "7 days",
        trial_description: "Free trial",
        trial_feature_1: "Limited access",
        trial_feature_2: "10 queries max",
        basic_label: "Basic",
        basic_duration: "/month",
        basic_description: "Basic plan",
        basic_feature_1: "100 queries/month",
        basic_feature_2: "Email support",
        normal_label: "Normal",
        normal_duration: "/month",
        normal_description: "Standard plan",
        normal_feature_1: "500 queries/month",
        normal_feature_2: "Priority support",
        normal_feature_3: "Basic analytics",
        premium_label: "Premium",
        premium_duration: "/month",
        premium_description: "Full plan",
        premium_feature_1: "Unlimited queries",
        premium_feature_2: "24/7 support",
        premium_feature_3: "Advanced analytics",
        free_label: "Free",
        free_price: "Free",
        free_duration: "Always",
        free_description: "Free plan",
        free_feature_1: "Basic access",
        free_feature_2: "Community support",
        processing: "Processing...",
      },
    },
  },
  es: {
    translation: {
      theCompany: "La Compañía",
      products: "Productos",
      contact_us: "Contáctanos",
      agent_title: "Nuestros agentes de IA están aquí para revolucionar la forma en que trabajas, piensas y creas.",
      agent_subtitle: "Ya sea que busque optimizar procesos, resolver desafíos complejos o innovar más rápido, tenemos la solución perfecta para usted.",
      privacy_policy: "Políticas de privacidad",
      terms_use: "Términos de uso",
      legal: "Legal",
      contact: "Contacto",
      help: "Ayuda",
      published_by: "Publicado por: ",
      see_more: "Ver más",
      initialMessage1: "Hola! 👋",
      initialMessage2: "Soy el kamaleon, en que puedo ayudarte hoy?",
      title: "Hola! 👋",
      subtitle: "Inicia un chat. Estamos disponibles las 24 horas, los 7 días de la semana.",
      footer: "",
      getStarted: "Nueva Conversación",
      inputPlaceholder: "Escribe una pregunta..",
      closeButtonTooltip: "", sign_in: "Iniciar Sesión",
      login: "Iniciar Sesión",
      for_customer: "Para Cliente",
      for_authors: "Para Autores",
      redirecting_to_app: "Redirigiendo a la aplicación...",
      video_not_supported: "Tu navegador no soporta la etiqueta de video.",
      specific_solutions: "¿Buscando una solución específica?",
      help_you: "Podemos ayudar!",
      new_agents_discover: "Descubre estos nuevos agentes",
      new_solutions: "¡Nuevas soluciones sólo para ti!",
      discover_hero_title: "Agentes especializados que trabajan 24/7 por una fracción del costo",
      discover_hero_subtitle: "Pagas por valor entregado: interacciones completadas y problemas resueltos.",
      discover_step_1_title: "Elige tus agentes",
      discover_step_1_desc: "Selecciona los agentes que necesita tu negocio",
      discover_step_2_title: "Integra en minutos",
      discover_step_2_desc: "Conecta con tus herramientas existentes",
      discover_step_3_title: "Escala sin límites",
      discover_step_3_desc: "Paga por las interacciones que consumes",
      discover_agents_title: "Nuestro agente",
      discover_agents_subtitle: "Conoce a tu nuevo equipo de élite",
      discover_agents_tagline: "Un agente especializado. Un solo objetivo: Multiplicar tu productividad",
      solutions_you: "Solo soluciones para ti!",
      recommend_agents: "Agentes recomendados para ti",
      find_interesting: "Puede que esto te resulte interesante",
      my_profile: "Mi Perfil",
      discover_agents_option: "Descubre Agentes",
      my_agents: "Mis Agentes",
      transactions: "Transacciones",
      sign_out: "Cerrar Sesión",
      error_loading_agents: "Ocurrio un error al cargar los agentes, intente de nuevo..",
      add: "Añadir",
      uses: "Usos",
      earning: "Ganancias",
      recordedOn: "Registrado en",
      usedSince: "Usado desde",
      seeMore: "Ver más",
      go_back: "Regresar",
      privacy: {
        title: "Manual Integral y Política Oficial de Protección de Datos Personales",
        subtitle: "Documento único que integra el Manual Corporativo, la Política de Protección de Datos, el Aviso de Privacidad, los Procedimientos, las Guías operativas y el Plan de Cumplimiento, conforme a la Ley Orgánica de Protección de Datos Personales (LOPDP) y normativa ecuatoriana aplicable.",
        s1_title: "1. Identificación Institucional",
        s1_responsible: "Responsable del tratamiento:",
        s1_responsible_value: "KRUGERCORPORATION S.A.S.",
        s1_type: "Tipo:",
        s1_type_value: "Sociedad por Acciones Simplificadas",
        s2_title: "2. Objeto del Documento",
        s2_p1: "Establecer el marco normativo, organizativo y operativo para garantizar la protección de los datos personales de sus clientes, trabajadores, y de terceros (proveedores) asegurando la tutela efectiva de los derechos de los titulares, la autodeterminación informativa y la seguridad de la información, en estricto cumplimiento de la Ley Orgánica de Protección de Datos Personales (LOPDP), su Reglamento General y la normativa técnica emitida por la Autoridad de Protección de Datos Personales.",
        s2_p2: "Este manual busca proteger los derechos y libertades fundamentales de los titulares, aplicando medidas técnicas y organizativas apropiadas, con prevalencia en la protección de datos sensibles.",
        s3_title: "3. Marco Legal Aplicable",
        s3_intro: "El tratamiento de datos personales se regirá por la siguiente jerarquía normativa:",
        s3_item1: "Constitución de la República del Ecuador",
        s3_item2: "Ley Orgánica de Protección de Datos Personales y su Reglamento",
        s3_item3: "Resoluciones de la Superintendencia de Protección de Datos Personales (SPDP)",
        s3_item4: "Código Orgánico Administrativo (COA)",
        s3_item5: "Código Orgánico Integral Penal (COIP)",
        s4_title: "4. Alcance de Aplicación",
        s4_intro: "Este documento es de cumplimiento obligatorio y aplica a todos los tratamientos de datos personales realizados por KRUGERCORPORATION S.A.S., en medios físicos y digitales, abarcando:",
        s4_material: "Ámbito Material:",
        s4_material_value: "Todo tratamiento de datos personales contenidos en cualquier tipo de soporte, sea este físico o digital, automatizados o no.",
        s4_lifecycle: "Ciclo de Vida del Dato:",
        s4_lifecycle_value: "Desde la recolección, registro, organización, conservación, hasta la eliminación, bloqueo o anonimización de la información.",
        s4_territory: "Territorialidad:",
        s4_territory_value: "Las actividades realizadas en el territorio ecuatoriano o aquellas sujetas a la legislación nacional en virtud de contratos.",
        s4_parties: "Partes Interesadas:",
        s4_parties_value: "Aplica a las relaciones con clientes, trabajadores, y de terceros (proveedores).",
        s5_title: "5. Definiciones",
        s5_consent: "Consentimiento:",
        s5_consent_value: "Manifestación de la voluntad libre, específica, informada e inequívoca, por el que el titular de los datos personales autoriza al responsable del tratamiento de los datos personales a tratar los mismos.",
        s5_personal_data: "Dato personal:",
        s5_personal_data_value: "Cualquier dato que identifica o hace identificable a una persona natural, directa o indirectamente.",
        s5_sensitive_data: "Dato sensible:",
        s5_sensitive_data_value: "Datos que requieren protección especial porque su uso indebido puede generar discriminación o atentar contra derechos fundamentales. Incluye: etnia, religión, salud, datos biométricos (huella digital, reconocimiento facial), datos genéticos, orientación sexual, pasado judicial, entre otros.",
        s5_processor: "Encargado del Tratamiento:",
        s5_processor_value: "Persona natural o jurídica, pública o privada, que sola o conjuntamente trata o procesa datos personales a nombre del responsable.",
        s5_controller: "Responsable del Tratamiento:",
        s5_controller_value: "Persona natural o jurídica, pública o privada, que solo o con otros decide sobre la finalidad y el tratamiento de los datos personales.",
        s5_processing: "Tratamiento:",
        s5_processing_value: "Cualquier operación o conjunto de operaciones realizadas sobre datos personales, ya sea por procedimientos técnicos de carácter automatizado, parcialmente automatizado o no automatizado, tales como: la recogida, recopilación, obtención, registro, organización, estructuración, conservación, custodia, adaptación, modificación, eliminación, indexación, extracción, consulta, elaboración, utilización, posesión, aprovechamiento, distribución, cesión, comunicación o transferencia, o cualquier otra forma de habilitación de acceso, cotejo, interconexión, limitación, supresión, destrucción y, en general, cualquier uso de datos personales.",
        s5_subject: "Titular:",
        s5_subject_value: "Persona natural cuyos datos son objeto de tratamiento.",
        s5_breach: "Vulneración de Seguridad:",
        s5_breach_value: "Incidente de seguridad que afecta la confidencialidad, disponibilidad o integridad de los datos personales.",
        s6_title: "6. Principios Rectores del Tratamiento",
        s6_intro: "KRUGERCORPORATION S.A.S aplicará estrictamente los siguientes principios en todo tratamiento de datos personales:",
        s6_legality: "Juridicidad:",
        s6_legality_value: "Los datos se tratarán con estricto apego a la Constitución, la LOPDP, su Reglamento y demás normativa aplicable.",
        s6_loyalty: "Lealtad y Transparencia:",
        s6_loyalty_value: "El tratamiento será leal y transparente. Toda información dirigida a los titulares será fácilmente accesible, fácil de entender y utilizará un lenguaje sencillo y claro. No se tratarán datos a través de medios ilícitos o desleales.",
        s6_purpose: "Finalidad:",
        s6_purpose_value: "Los datos serán recolectados con fines determinados, explícitos y legítimos. No se tratarán posteriormente de manera incompatible con dichos fines, salvo las excepciones de ley.",
        s6_minimization: "Pertinencia y Minimización:",
        s6_minimization_value: "Los datos recabados serán pertinentes y se limitarán a lo estrictamente necesario para el cumplimiento de la finalidad.",
        s6_proportionality: "Proporcionalidad:",
        s6_proportionality_value: "El tratamiento será adecuado, necesario, oportuno, relevante y no excesivo en relación con las finalidades para las que se hayan recogido.",
        s6_security: "Seguridad:",
        s6_security_value: "Se implementarán medidas de seguridad técnicas, físicas y organizativas adecuadas para proteger los datos frente a riesgos, amenazas o vulnerabilidades.",
        s6_confidentiality: "Confidencialidad:",
        s6_confidentiality_value: "Se garantizará el debido sigilo y secreto. Los datos no serán comunicados a terceros para fines distintos a los autorizados, salvo obligación legal. Esta obligación de confidencialidad se mantiene aún después de finalizar la relación con la compañía.",
        s6_quality: "Calidad y Exactitud:",
        s6_quality_value: "Los datos deben ser exactos, íntegros, precisos y estar debidamente actualizados. La compañía adoptará medidas para rectificar o suprimir aquellos que sean inexactos.",
        s6_conservation: "Conservación:",
        s6_conservation_value: "Los datos se conservarán únicamente durante el tiempo necesario para cumplir la finalidad del tratamiento. Una vez cumplida, se procederá a su eliminación, bloqueo o anonimización, salvo obligación legal de conservarlos.",
        s6_accountability: "Responsabilidad proactiva y Demostrada:",
        s6_accountability_value: "La compañía acreditará haber implementado mecanismos para la protección de datos y será capaz de demostrar el cumplimiento de estos principios ante la Autoridad y los titulares. Esto incluye la protección de datos desde el diseño y por defecto.",
        s6_favorable: "Aplicación Favorable al Titular:",
        s6_favorable_value: "En caso de duda sobre el alcance de una norma, se interpretará y aplicará en el sentido más favorable al titular de los datos.",
        s7_title: "7. Derechos de los Titulares de Datos Personales",
        s7_intro: "Como compañía, conocemos que los titulares de los datos personales respecto de los cuales somos responsables son los previstos en el Régimen de Protección de Datos Personales en la República del Ecuador, especialmente los siguientes:",
        s7_right1: "i. Acceder en forma gratuita a los datos proporcionados que hayan sido objeto de tratamiento;",
        s7_right2: "ii. Solicitar la actualización y rectificación de la información frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o a aquellos cuyo tratamiento esté prohibido o no haya sido autorizado;",
        s7_right3: "iii. Solicitar prueba de la autorización otorgada;",
        s7_right4: "iv. Presentar quejas por infracciones a lo dispuesto en la normatividad vigente;",
        s7_right5: "v. Revocar la autorización y/o solicitar la supresión del dato, a menos que exista un deber legal o contractual que haga imperativo conservar la información;",
        s7_right6: "vi. Abstenerse de responder las preguntas sobre datos sensibles;",
        s7_right7: "vii. Solicitar la modificación, rectificación y/o eliminación de la información almacenada en las bases de datos de KRUGER;",
        s7_right8: "viii. Solicitar el acceso inmediato a sus datos personales;",
        s7_right9: "ix. Derecho a la oposición;",
        s7_right10: "x. Derecho a la portabilidad de sus datos personales;",
        s7_right11: "xi. Derecho a la suspensión del tratamiento;",
        s7_right12: "xii. Derecho a consultar qué tipos de datos tiene el responsable del tratamiento de datos personales.",
        s7_sensitive: "En relación con el tratamiento de datos sensibles, KRUGER garantiza que estos estarán sujetos en todo momento a ser confidenciales, protegidos contra el tratamiento no autorizado o ilícito, contra su daño o pérdida, así como al secreto confidencial en todo caso, de conformidad con las disposiciones legales consagradas en la Ley Orgánica de Protección de Datos Personales.",
        s8_title: "8. Canales de Contacto y Tiempo de Atención",
        s8_intro: "La compañía deberá buscar en todo momento poner a disponibilidad de sus clientes y de sus trabajadores, las Política de Tratamiento de Datos Personales de KRUGER, con la finalidad de hacer valer y garantizar los derechos constitucionalmente reconocidos relacionados con el tratamiento de datos personales. Se han definido como canales de atención de solicitudes, peticiones, consultas y/o quejas los siguientes:",
        s8_channel1: "Correo electrónico",
        s8_channel2: "Números telefónicos",
        s8_channel3: "Oficinas de KRUGER ubicadas en Arizaga Luque N34-206 y Federico Páez, Edificio K+, Batán Alto",
        s8_response: "KRUGER mediante su delegado de Protección de Datos Personales, atenderá y dará respuesta a todas las consultas, peticiones, solicitudes o reclamos relacionados con sus datos personales en el plazo establecido en la Ley Orgánica de Protección de Datos Personales. KRUGER atenderá sus solicitudes en el menor tiempo posible, sin que este supere el plazo legal de 15 días hábiles y/o de 30 días, dependiendo del tipo de requerimiento.",
        s9_title: "9. Obtención de Datos Personales",
        s9_intro: "KRUGER obtiene datos personales de sus clientes y trabajadores, incluyendo, cuando sea necesario, datos personales de categoría especial o sensible, siempre en observancia de las bases de licitud previstas en la LOPDP y adoptando medidas reforzadas de seguridad y confidencialidad para su tratamiento. La obtención se realiza directamente del titular, a través de formularios físicos o electrónicos, canales de atención, contratos, comunicaciones, grabaciones de videovigilancia y llamadas, así como de fuentes de acceso público o legítimamente autorizadas.",
        s9_general_title: "i. Datos personales generales identificativos",
        s9_general_content: "Nombres y apellidos, número de cédula, registro único de contribuyentes, nacionalidad, número de teléfono convencional y celular, dirección de domicilio, dirección de correo electrónico, dirección del trabajo, identidad cultural, fecha de nacimiento, nombres y apellidos de los cónyuges de los trabajadores, fecha de matrimonio o unión de hecho, domicilio del trabajador, tipo de vivienda, lugar de nacimiento, condición migratoria, ocupación y aficiones, experiencia profesional, datos académicos, de tránsito y migratorios; información sobre procedimientos legales; imágenes de video grabadas a través de cámaras de vigilancia; y registros de llamadas telefónicas.",
        s9_special_title: "ii. Datos Especiales",
        s9_special_intro: "La empresa realiza tratamiento de distintas categorías especiales de datos personales:",
        s9_sensitive_data: "Datos Personales Sensibles:",
        s9_sensitive_data_value: "tales como datos de salud, características físicas, inclinaciones ideológicas, sexo, género, altura, peso, información sobre familiares fallecidos, identidad de género, orientación sexual, y datos de georreferenciación o geolocalización del personal.",
        s9_biometric: "Datos Biométricos:",
        s9_biometric_value: "relativos a las características físicas o fisiológicas o conductas de nuestros clientes y personal, que proporcionan información única sobre su fisiología o salud. Incluye procesos de reconocimiento de voz, almacenamiento de imagen, recolección de firmas, código dactilar y datos de geolocalización.",
        s9_minors: "Datos de Menores de Edad:",
        s9_minors_value: "relativos a hijos e hijas de trabajadores, tales como número de hijos, edad y condiciones médicas especiales, tratados exclusivamente con el consentimiento expreso y verificable de sus padres, madres o representantes legales.",
        s9_medical: "Datos Médicos:",
        s9_medical_value: "incluyendo enfermedades catastróficas, discapacidades, estado de salud, diagnósticos, ficha médica, datos genéticos, datos de salud mental, antecedentes médicos, seguro médico, alergias, medicinas, grupo sanguíneo, tratamientos y procedimientos médicos, resultados de exámenes.",
        s9_labor: "Datos Laborales:",
        s9_labor_value: "datos del cargo y compañía, referencias laborales, evaluaciones de desempeño, aptitudes del trabajador, así como cualquier otra información necesaria para la relación laboral o contractual.",
        s9_credit_title: "iii. Datos Crediticios",
        s9_credit_content: "Datos patrimoniales y financieros, de identificación y laborales, tales como número de cuenta bancaria, datos personales crediticios (información sobre activos, pasivos, capital), código CIF, domicilio fiscal de proveedores, tipo de cuenta, tipo de banco, seguros privados y públicos, sueldo, honorarios, comisiones, proyección de gastos, inversiones, detalle patrimonial, declaraciones y comprobantes de pagos de impuestos, pensiones laborales, créditos y capacidad de endeudamiento.",
        s9_public_title: "iv. Datos Públicos",
        s9_public_content: "Sentencias y sanciones interpuestas por las autoridades judiciales, órdenes de prisión, pensiones alimenticias, órdenes de alejamiento, denuncias administrativas o penales, certificado de antecedentes penales.",
        s10_title: "10. Roles y Responsabilidades",
        s10_company_title: "10.1. La Compañía (Dirección General)",
        s10_company_intro: "Actúa como Responsable del Tratamiento y sus obligaciones son:",
        s10_company_proactive: "Responsabilidad Proactiva:",
        s10_company_proactive_value: "Acreditar y demostrar el cumplimiento de los principios y obligaciones de la LOPDP mediante políticas, procedimientos y medidas de seguridad verificables.",
        s10_company_decisions: "Toma de Decisiones:",
        s10_company_decisions_value: "Definir las finalidades y los medios del tratamiento.",
        s10_company_resources: "Gestión de Recursos:",
        s10_company_resources_value: "Garantizar la asignación de recursos económicos, humanos y técnicos necesarios para la implementación de medidas de seguridad.",
        s10_company_breach: "Notificación de Brechas:",
        s10_company_breach_value: "Notificar a la Autoridad de Protección de Datos y a los titulares sobre vulneraciones de seguridad dentro de los términos legales establecidos.",
        s10_dpo_title: "10.2. Delegado de Protección de Datos (DPO)",
        s10_dpo_intro: "Es el profesional encargado de asesorar y supervisar el cumplimiento normativo:",
        s10_dpo_supervision: "Supervisión y Asesoría:",
        s10_dpo_supervision_value: "Informar y asesorar a KRUGER sobre sus obligaciones legales y supervisar su cumplimiento.",
        s10_dpo_contact: "Punto de Contacto:",
        s10_dpo_contact_value: "Actuar como enlace entre KRUGER, la Autoridad de Protección de Datos y los titulares.",
        s10_dpo_independence: "Independencia:",
        s10_dpo_independence_value: "Desempeñar sus funciones con total independencia, sin recibir instrucciones sobre cómo realizar sus tareas.",
        s10_dpo_confidentiality: "Confidencialidad:",
        s10_dpo_confidentiality_value: "Mantener estricto secreto sobre la información que conozca en el ejercicio de sus funciones.",
        s10_staff_title: "10.3. Personal a quien corresponda el manejo de información",
        s10_staff_secrecy: "Confidencialidad y Sigilo:",
        s10_staff_secrecy_value: "Guardar secreto sobre los datos personales a los que tengan acceso.",
        s10_staff_use: "Uso Legítimo:",
        s10_staff_use_value: "Tratar los datos únicamente para los fines autorizados.",
        s10_staff_report: "Reporte de Incidentes:",
        s10_staff_report_value: "Notificar de forma inmediata al DPO cualquier sospecha de vulneración de seguridad.",
        s10_processor_title: "10.4. Encargados del Tratamiento (Proveedores)",
        s10_processor_contractual: "Cumplimiento Contractual:",
        s10_processor_contractual_value: "Tratar los datos únicamente siguiendo las instrucciones documentadas y firmar cláusulas de confidencialidad y protección de datos.",
        s10_processor_security: "Medidas de Seguridad:",
        s10_processor_security_value: "Implementar medidas de seguridad equivalentes a las de la compañía y garantizar la devolución o eliminación de los datos al finalizar el contrato.",
        s11_title: "11. Limitación de Responsabilidad",
        s11_p1: "KRUGER no asumirá responsabilidad por daños o perjuicios, directos o indirectos, que se deriven o estén relacionados con el acceso o uso de sus páginas web y medios digitales, incluso si hubiera tenido conocimiento previo de la posibilidad de dichos daños. Esto incluye la responsabilidad por daños ocasionados por virus que pudieran infectar los sistemas de cómputo de clientes o usuarios.",
        s11_p2: "KRUGER, al recabar datos personales, procurará que el titular declare, mediante los mecanismos habilitados para obtener su consentimiento, que:",
        s11_declaration1: "i. Ha sido informado de manera clara y expresa sobre el tratamiento al que serán sometidos sus datos personales.",
        s11_declaration2: "ii. Conoce las finalidades para las que se tratarán sus datos.",
        s11_declaration3: "iii. En caso de recolección de datos sensibles, tiene derecho a contestar o no las preguntas formuladas y a decidir si entrega o no la información solicitada.",
        s11_declaration4: "iv. Conoce los derechos que le asisten como titular de datos personales.",
        s11_declaration5: "v. Conoce la identificación, dirección física o electrónica y teléfono de KRUGER en calidad de responsable del tratamiento.",
        s12_title: "12. Gestión de Incidentes y Brechas de Seguridad",
        s12_intro: "Todo incidente deberá ser reportado de inmediato, documentado, evaluado y corregido. En caso de riesgo significativo, se notificará a la Superintendencia de Protección de Datos Personales y a los titulares afectados.",
        s12_detection_title: "12.1. Detección y Registro Interno",
        s12_detection1: "Cualquier miembro de la Compañía que detecte una posible vulneración debe reportarla inmediatamente al DPO.",
        s12_detection2: "Si la brecha ocurre en un proveedor, este tiene la obligación legal de notificar al DPO en un término máximo de dos (2) días.",
        s12_detection3: "Se registrará el incidente detallando: naturaleza, fecha, datos comprometidos y consecuencias probables.",
        s12_risk_title: "12.2. Evaluación del Riesgo",
        s12_risk1: "El DPO y el área técnica evaluarán si la violación constituye un riesgo para los derechos y libertades de los titulares.",
        s12_risk2: "Se determinará el volumen de datos, tipo de datos y la causa.",
        s12_authority_title: "12.3. Notificación a la Autoridad (Plazo: 5 días)",
        s12_authority_content: "Si existe riesgo, la Compañía notificará a la Superintendencia de Protección de Datos Personales y a la ARCOTEL, tan pronto sea posible, y a más tardar en el término de cinco (5) días. La notificación incluirá: naturaleza de la vulneración, categorías de afectados, medidas adoptadas y contacto del DPO.",
        s12_subjects_title: "12.4. Comunicación a los Titulares (Plazo: 3 días)",
        s12_subjects_content: "Si la violación entraña un alto riesgo para los derechos fundamentales, se comunicará a los afectados dentro del término de tres (3) días, en lenguaje claro y sencillo, explicando las posibles consecuencias y las medidas que pueden tomar para protegerse.",
        s12_corrective_title: "12.5. Medidas Correctivas y de Contención",
        s12_corrective1: "Se implementarán acciones inmediatas para frenar la incidencia.",
        s12_corrective2: "Se documentará el incidente y las soluciones aplicadas para prevenir su repetición.",
        s13_title: "13. Transferencias de Datos y Relación con Terceros",
        s13_p1: "KRUGER podrá transferir sus datos personales a terceros, tanto nacionales como domiciliados en el extranjero, tales como subsidiarias, empresas relacionadas, proveedores de servicios y aliados estratégicos con los que mantenga una relación jurídica.",
        s13_intro: "Las transferencias podrán realizarse a:",
        s13_item1: "Autoridades administrativas en la República del Ecuador y autoridades financieras ecuatorianas y extranjeras.",
        s13_item2: "Autoridades judiciales, ecuatorianas y extranjeras.",
        s13_item3: "Instituciones de la Seguridad Social.",
        s13_item4: "Instituciones, organizaciones o entidades del sector para fines de prevención de fraude y evaluación de riesgos.",
        s13_item5: "Empresas proveedoras de servicios relacionados con las actividades de KRUGER.",
        s13_item6: "Proveedores y contratistas necesarios para el cumplimiento de la relación jurídica con el titular.",
        s13_sensitive: "KRUGER, en caso de requerir transferir datos personales sensibles a terceros, obtendrá siempre el consentimiento expreso y por escrito de sus clientes y trabajadores.",
        s14_title: "14. Actualización de Fotografías del Trabajador y/o Colaborador",
        s14_item1: "La Empresa coordinará con cada trabajador y/o colaborador la actualización de su fotografía, la cual deberá renovarse cada cinco (5) años.",
        s14_item2: "El trabajador y/o colaborador será responsable de entregar una fotografía actualizada en el plazo establecido.",
        s14_item3: "La Empresa será responsable de la custodia y protección de las fotografías actualizadas, garantizando el tratamiento adecuado y seguro de esta información.",
        s15_title: "15. Finalidades del Tratamiento de Datos Personales",
        s15_clients_title: "15.1. Clientes",
        s15_clients_item1: "Análisis de la capacidad del proveedor para cumplir con el contrato.",
        s15_clients_item2: "Gestión de la relación contractual con el proveedor.",
        s15_clients_item3: "Facturación y pagos de valores por bienes y/o servicios.",
        s15_clients_item4: "Coordinación de entrega del producto y/o servicio.",
        s15_clients_item5: "Comunicación con el proveedor.",
        s15_clients_item6: "Gestión de beneficios comerciales con el proveedor.",
        s15_clients_item7: "Cumplimiento de obligaciones legales y normativas aplicables.",
        s15_clients_item8: "Actividades comerciales propias de la relación con el cliente o proveedor.",
        s15_clients_item9: "Implementación de proyectos vinculados al giro del negocio de la compañía.",
        s15_clients_item10: "Ejecución de lo establecido en el contrato y en la normativa aplicable.",
        s15_secondary_title: "15.2. Finalidades Secundarias",
        s15_secondary_item1: "Ofrecimiento y promoción de bienes, productos y servicios y/o prospección comercial.",
        s15_secondary_item2: "Gestionar alianzas interinstitucionales.",
        s15_secondary_item3: "Mercadotecnia, publicidad, prospección comercial, evaluación de productos y servicios.",
        s15_secondary_item4: "Contacto en caso de solicitudes, quejas y/o reclamos.",
        s15_secondary_item5: "Gestiones de venta directa de los productos o servicios ofertados por KRUGER.",
        s15_secondary_item6: "Encuestas, estudios y/o confirmación de datos personales.",
        s15_secondary_item7: "Análisis estadísticos internos o envío de noticias relacionadas con mejoras de servicio.",
        s15_secondary_item8: "Trámites ante autoridades en la República del Ecuador.",
        s15_secondary_item9: "Servicio al cliente y/o proveedor.",
        s15_secondary_item10: "Personalización de contenidos.",
        s15_secondary_item11: "Investigación y desarrollo de modelos de negocios.",
        s15_secondary_item12: "Gestiones de cobranza de valores adeudados a la compañía.",
        s15_labor_title: "15.3. Relaciones Laborales",
        s15_labor_item1: "Cumplimiento del contrato laboral.",
        s15_labor_item2: "Cumplimiento de obligaciones legales de la compañía.",
        s15_labor_item3: "Cumplimiento de lo establecido por el Código de Trabajo y otras normas aplicables.",
        s15_labor_item4: "Gestión, planificación y organización del trabajo, así como la promoción de la igualdad y la seguridad en el lugar de trabajo.",
        s15_labor_item5: "Gestión y administración de recursos humanos.",
        s15_labor_item6: "Cumplimiento de planes ocupacionales.",
        s15_labor_item7: "Aplicación de políticas corporativas de la compañía.",
        s15_labor_item8: "Provisión de medidas de salud y seguridad en el trabajo.",
        s15_labor_item9: "Pago del beneficio de utilidades conforme al cálculo de las cargas familiares.",
        s15_labor_item10: "Entrega de información a autoridades del Ministerio de Trabajo y del Instituto Ecuatoriano de Seguridad Social.",
        s15_labor_item11: "Atención de solicitudes del trabajador para referencias laborales.",
        s15_labor_item12: "Uso de cámaras de videovigilancia en espacios de trabajo, con finalidades exclusivas de precautelar la salud, la seguridad y la protección de las personas y bienes.",
        s16_title: "16. Tiempo de Tratamiento y Almacenamiento de los Datos Personales",
        s16_p1: "Los datos personales serán conservados por KRUGER durante el tiempo estrictamente necesario para cumplir con las finalidades indicadas en esta Política, o mientras exista una base legal que lo justifique, y/o hasta que el titular ejerza su derecho de oposición o revoque su consentimiento.",
        s16_p2: "Como regla general, los datos personales se almacenarán en servidores ubicados en la República del Ecuador. De manera excepcional, podrán ser almacenados fuera del territorio ecuatoriano en las siguientes jurisdicciones: Perú, Colombia, Costa Rica, Panamá, Nicaragua, Guatemala, El Salvador, Estados Unidos, España, Bolivia, México y Uruguay.",
        s16_p3: "La compañía garantiza que los datos personales no serán almacenados de forma indefinida y que anualmente realizará una revisión de sus bases de datos y servidores, a fin de segregar correctamente los datos y garantizar procesos de eliminación segura y verificada.",
        s17_title: "17. Evaluación de Impacto en la Protección de Datos (EIPD)",
        s17_p1: "Conforme al artículo 42 de la LOPDP y los artículos 29 al 32 del Reglamento General, KRUGER realizará una Evaluación de Impacto previa a la implementación de cualquier nuevo sistema o tecnología que implique un alto riesgo para los derechos.",
        s17_mandatory: "Obligatoriedad:",
        s17_mandatory_value: "Será obligatorio realizar este análisis técnico cuando se traten datos de personas con discapacidad, datos de salud o perfiles psicológicos de forma masiva.",
        s17_procedure: "Procedimiento:",
        s17_procedure_value: "El Delegado de Protección de Datos (DPO) liderará este análisis para identificar riesgos y establecer medidas mitigantes antes de iniciar el tratamiento.",
        s18_title: "18. Política de Protección de Datos Personales",
        s18_content: "La compañía KRUGERCORPORATION S.A.S actuará como Responsable del Tratamiento de los Datos Personales de sus clientes, trabajadores, y de terceros (proveedores), datos personales que incluyen nombres, dirección, número de cédula, fecha de nacimiento, datos relativos a la salud, datos de contacto como teléfono de domicilio, teléfono celular, correo electrónico, datos sensibles, entre otros. KRUGER podrá tratar datos personales de menores únicamente con el consentimiento expreso y verificable de sus padres, madres o representantes legales, adoptando medidas reforzadas de seguridad y confidencialidad para proteger esta información.",
        s19_title: "19. Garantías Institucionales",
        s19_intro: "La compañía garantiza la aplicación de los siguientes principios y medidas:",
        s19_confidentiality: "Confidencialidad y Sigilo:",
        s19_confidentiality_value: "Los datos no serán revelados a terceros no autorizados.",
        s19_security: "Seguridad de la Información:",
        s19_security_value: "Se implementan medidas técnicas y organizativas para evitar la pérdida, acceso no autorizado o alteración de los datos.",
        s19_minimization: "Minimización y Conservación:",
        s19_minimization_value: "Solo se recabarán los datos estrictamente necesarios y se conservarán durante el tiempo exigido por la normativa; una vez cumplido el plazo, se procederá a su eliminación segura.",
        s20_title: "20. Aviso de Privacidad",
        s20_responsible: "Responsable y Finalidad:",
        s20_responsible_value: "KRUGERCORPORATION S.A.S., tratará los datos personales proporcionados para la gestión de la información correspondiente a procedimientos internos dentro de la Compañía.",
        s20_legitimation: "Legitimación y Transferencias:",
        s20_legitimation_value: "El tratamiento es necesario para la ejecución contractual y el cumplimiento de obligaciones legales. Los datos estrictamente necesarios podrán ser comunicados a entidades públicas de control y proveedores de servicios complementarios autorizados.",
        s20_conservation: "Tiempo de Conservación:",
        s20_conservation_value: "La información se conservará durante la vigencia de la obligación contractual y posteriormente durante los plazos legales exigidos por la normativa correspondiente para cada procedimiento.",
        s20_rights: "Derechos del Titular:",
        s20_rights_value: "Puede ejercer sus derechos de acceso, rectificación, eliminación, oposición, suspensión y portabilidad.",
        s21_title: "21. Consentimiento Libre e Informado",
        s21_p1: "En cumplimiento de lo dispuesto por la Ley Orgánica de Protección de Datos Personales, KRUGER informa que tratará los datos personales que usted proporcione, de conformidad con las finalidades descritas en la presente Política.",
        s21_p2: "KRUGER podrá recopilar o recibir sus datos a través de sus sitios web, formularios, aplicaciones, dispositivos, páginas de marcas o productos, redes sociales o por cualquier otro medio físico o virtual.",
        s21_p3: "Mediante la aceptación de esta Política, usted otorga su consentimiento voluntario, libre, previo, expreso, específico, informado e inequívoco a KRUGER, sus subsidiarias, filiales o vinculadas, así como a terceros, contratistas y proveedores que actúen en su nombre, para realizar el tratamiento, almacenamiento, destino, flujo y transferencia, en cualquiera de sus modalidades, medios o soportes, sea local o transfronterizo, de la información y datos personales que usted haya proporcionado bajo cualquier medio o modalidad.",
        s22_title: "22. Mecanismos y Procedimientos para la Revocación del Consentimiento",
        s22_p1: "En todo momento nuestros clientes y trabajadores podrán revocar el consentimiento que nos han otorgado como KRUGER para el tratamiento de sus datos personales. Sin embargo, es importante tener en cuenta que no en todos los casos podremos atender dichas solicitudes o concluir su uso de forma inmediata, ya que es posible que por alguna obligación legal se requiera seguir tratando sus datos personales.",
        s22_p2: "Para solicitar la revocación del consentimiento, los titulares podrán acudir personalmente a las oficinas de KRUGER ubicadas en Arizaga Luque N34-206 y Federico Páez, Edificio K+, Batán Alto; y/o enviar un correo electrónico indicando su \"Solicitud de Revocación del Consentimiento\" acompañando los documentos que acrediten su identidad.",
        s22_p3: "KRUGER debe procurar atender la petición de sus clientes en los tiempos estipulados en las leyes aplicables, esto es entre 15 a 30 días dependiendo del tipo de requerimiento.",
        s23_title: "23. Vigencia y Aprobación",
        s23_validity: "Vigencia:",
        s23_validity_value: "Entra en vigor a partir de su suscripción y difusión.",
        s23_review: "Revisión:",
        s23_review_value: "Se revisará anualmente o cuando existan cambios normativos relevantes por parte de la Superintendencia de Protección de Datos.",
      },
      edit_agent: "Editar Agente",
      Edit: "Editar",
      Delete: "Eliminar",
      "Are you sure you want to delete this description? This action cannot be undone.": "¿Estás seguro de que quieres eliminar esta descripción? Esta acción no se puede deshacer.", confirmDelete: {
        title: "Confirmar Eliminación",
        message: "¿Estás seguro de que quieres eliminar esta descripción? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        confirm: "Eliminar"
      },      
      agent_information: "Información del Agente",
      default_agent_description: "Aún no hay descripción detallada disponible para esta sección.",
      no_descriptions_available: "No hay descripciones disponibles",
      mantra_details: "Crea chatbots inteligentes alimentados con tu propio conocimiento. Sube documentos, agrega URLs y construye una base de conocimiento personalizada que tu chatbot utiliza para entregar respuestas precisas y contextuales. Personaliza fácilmente su apariencia, comportamiento y tono, luego intégralo en tu sitio web o aplicación con solo unos clics. Monitorea el uso, revisa conversaciones y mejora continuamente el rendimiento de tu chatbot — todo desde un panel intuitivo y centralizado.",
      acquire_agent_marketplace: "Comprar ahora",
      acquired: "Adquirido",
      expiredPlan:"Plan vencido",
      freeAcquired: "Plan gratis adquirido",
      upgradePlan:"Actualizar Plan",
      loading: "Cargando...",
      processing_payment: "Procesando pago...",
      error_purchasing_agent: "Error al adquirir el agente",
      agent_purchased_successfully: "¡Agente adquirido exitosamente!",
      purchase_success: "¡Agente adquirido exitosamente!",
      purchase_error: "Error al adquirir el agente",
      error_loading_purchase_state: "Error al cargar el estado de compra",
      filter_by_authors: "Filtrar por autores",
      select_authors: "Seleccionar autores",
      search_authors: "Buscar autores...",
      clear_all: "Limpiar todo",
      clear_search: "Limpiar búsqueda",
      apply_filter: "Aplicar filtro",
      apply_filters: "Aplicar filtros",
      clear_filters: "Limpiar filtros",
      loading_authors: "Cargando autores...",
      loading_more: "Cargando más...",
      no_more_authors: "No hay más autores",
      no_authors_found: "No se encontraron autores",
      no_more_agents: "No hay más agentes",
      no_agents_found: "No se encontraron agentes.",
      my_purchased_agents_title: "Mis Agentes Adquiridos",
      loading_text: "Cargando...",
      error_loading_agents_purchased: "Error al cargar los agentes",
      error_loading_agents_retry: "Por favor, intenta de nuevo más tarde",
      loading_more_agents: "Cargando más...",
      no_more_agents_purchased: "No hay más agentes",
      no_purchased_agents_found: "No se encontraron agentes comprados",
      no_purchased_agents_hint: "Intenta más tarde o compra un agente",
      plan_acquired: "Plan adquirido",
      published_by_kaiman: "Publicado por KAIman",
      // Traducciones para el modal de planes
      plan_modal: {
        title: "Selecciona un plan",
        cta: "Pagar - {{price}}",
        per_month: "/mes",
        opening_payment_gateway: "Abriendo pasarela de pago...",
        awaiting_payment: "Esperando confirmación de pago...",
        processing_payment: "Procesando pago...",
        full_access: "Acceso completo",
        plans: {
          Free: {
            title: "Gratis",
            subtitle: "Gratis",
            desc: "Plan gratuito para pruebas",
            perks: ["Acceso limitado", "Ideal para pruebas"]
          },
          Standard: {
            title: "Standard",
            subtitle: "Popular",
            desc: "Todas las funciones básicas",
            perks: ["Acceso completo", "Soporte básico"]
          },
          Premium: {
            title: "Premium",
            subtitle: "Mejor valor",
            desc: "Todas las funciones, proyectos ilimitados, soporte prioritario",
            perks: ["Acceso completo", "Soporte prioritario", "Consultas ilimitadas"]
          }
        }
      },
      pricing_page: {
        title_prefix: "Elige cómo quieres",
        title_highlight: "escalar con IA",
        subtitle: "Empieza con lo esencial y evoluciona a medida que tus procesos crecen. Nuestros agentes se adaptan a tu ritmo.",
        badge_refund: "Garantía de reembolso de 30 días",
        badge_support: "Asistencia las 24 horas",
        badge_cancel: "Cancela en cualquier momento",
        featured_badge: "MÁS VENDIDO",
        month: "mes",
        conversations: "Conversaciones",
        choose_plan: "Elegir Plan",
        plan_selected: "Plan Seleccionado",
        disclaimer: "Todos los planes se pagan por adelantado. La tarifa mensual refleja el precio total del plan dividido entre la cantidad de meses que lo componen.",
        benefits_title: "Disfruta de todo esto sin ningún coste adicional",
        benefit_ssl: "Certificados de seguridad SSL ilimitados",
        benefit_updates: "Actualizaciones y backups automáticos",
        benefit_domain: "Dominio gratis (con planes anuales)",
        benefit_email: "Direcciones de email",
        benefit_templates: "Plantillas diseñadas profesionalmente",
        benefit_traffic: "Tráfico web ilimitado",
        compare_plans: "Comparar Planes",
        compare_plans_title: "Compara nuestros planes",
        compare_plans_subtitle: "Echa un vistazo cuánto cuesta cada plan y qué obtienes al pagar por ello.",
      },
      plan_units: {
        whatsapp: "Uso de Whatsapp con el chatbot ",
        leads: "Validación de Leads y listado",
        webhooks: "Webhooks de leads en tiempo real",
        chatbot: "{{count}} Chatbot",
        chatbots: "{{count}} Chatbots",
        conversation: "{{count}} conversación al mes",
        conversations: "{{count}} conversaciones al mes",
        knowledge_source: "Hasta {{count}} sitio web de referencia",
        knowledge_sources: "Hasta {{count}} sitios web de referencia",
        knowledge_file: "Hasta {{count}} archivo",
        knowledge_files: "Hasta {{count}} archivos",
        knowledge_file_size: "Hasta {{count}} MB por archivo",
        ai_basic: "Modelo IA básico",
        ai_standard: "Modelo IA estándar",
        ai_advanced: "Modelo IA avanzado"
      },
      agent_relations_modal: {
        acquire_agent: "Adquirir Agente",
        select_plan: "Selecciona Plan"
      },
      agent_terms: {
        accept_label: "Acepto los",
        terms_link: "términos y condiciones",
        modal_title: "Términos y Condiciones"
      },
      active_filters: "Filtros activos",
      filter_by_states: "Filtrar por estados",
      select_states: "Seleccionar estados",
      search_states: "Buscar estados...",
      no_states_found: "No se encontraron estados",
      active_state_filters: "Estados activos",
      name_or_summary: "Nombre o resumen",
      search_name_summary: "Buscar por nombre o resumen...",
      registered_by_me: "Registrados por mi",
      search: "Buscar",
      reset_filters: "Reiniciar filtros",
      no_results_found: "No se encontraron resultados",
      error_loading_results: "Error al cargar los resultados",
      // ApiDefinitionForm keys
      api_error_message: "Ocurrió un error al comunicarse con la API. Por favor, inténtalo de nuevo más tarde.",
      api_creating_message: "Se está realizando la configuración automática de la API, espere por favor...",
      api_updating_message: "Se está actualizando la configuración automática de la API, espere por favor...",
      download_swagger_label: "Descargar Swagger",
      swagger_file_description: "Descarga el archivo actual de definición Swagger/OpenAPI para esta API.",
      download_swagger_short: "Descargar",
      alias: "Alias",
      alias_error: "No se permiten caracteres especiales: ~!@#;:%^()+={}|\\<>\"',&$[]/",
      alias_placeholder: "Ej: api-mi-servicio",
      alias_help: "Nombre único de la API en WSO2. Máximo 50 caracteres.",
      alias_tooltip: "Nombre que se le dará a la API en WSO2. Este nombre es único y no puede ser modificado.<br/><b>Ejemplo:</b> <span class='text-blue-500'>my-service-api</span>",
      domain: "Dominio",
      domain_placeholder: "Ej: https://api.example.com/services",
      api_to_get_plans_of_application: "API para obtener los planes de suscripción",
      api_to_create_subscription: "API para crear la suscripción",
      api_to_webhook_subscription: "API para registrar el pago recurrente de la suscripción",
      domain_help: "Dominio base de los servicios web. Máximo 232 caracteres.",
      domain_tooltip: "Dominio en el cual se encuentran alojados los servicios web. Es la parte común de las URLs de tus endpoints.<br/><b>Ejemplo:</b> <span class='text-blue-500'>https://api.example.com/services</span><br/><ul class='list-disc pl-4 mt-1'><li>https://api.example.com/services/persons <span class='text-gray-400'>(GET)</span></li><li>https://api.example.com/services/persons/{id} <span class='text-gray-400'>(DELETE)</span></li><li>https://api.example.com/services/persons/{id} <span class='text-gray-400'>(PUT)</span></li></ul>El dominio sería: <b>https://api.example.com/services</b>",
      auth_type: "Tipo Autenticación",
      oauth2: "OAuth2",
      basic: "Básico",
      apikey: "Apikey",
      auth_type_help: "Selecciona el tipo de autenticación requerido.",
      duration: "Duración",
      minutes: "Minutos",
      hours: "Horas",
      days: "Días",
      apikey_time_help: "Tiempo de expiración del API Key.",
      swagger_label: "JSON swagger",
      browse: "Buscar",
      or_drag: "o arrastra aquí",
      swagger_help: "Sube el archivo swagger de los servicios web.",
      selected_file: "Archivo seleccionado: {{name}}",
  
      cancel: "Cancelar",
      continue: "Continuar",
      confirm_title: "¿Estás seguro de guardar la configuración?",
      confirm_text_create: "Crear esta configuración puede afectar el comportamiento de la API. ¿Está seguro de continuar?",
      confirm_text_update: "Modificar los parámetros de configuración puede causar que el funcionamiento anterior de la API varíe, ¿Está seguro de continuar?",
      confirm: "Confirmar",
      update: "Actualizar",
      relation_tab: {
        saving: "Guardando cambios...",
        saved: "¡Cambios guardados!",
        loading: "Cargando agentes relacionados...",
        no_agents: "No hay agentes relacionados",
        name: "Nombre",
        summary: "Resumen",
        relation: "Relación",
        obligatory: "Obligatorio",
        actions: "Acciones",
        yes: "Sí",
        no: "No",
        agent_already_added: "Este agente ya está agregado con esta relación",
        agent_added: "Agente agregado exitosamente",
        saving_relation: "Guardando relación...",
        error_adding_agent: "Error al agregar el agente",
        error_updating: "Error al actualizar la relación",
        error_updating_relation: "Error al actualizar la relación del agente",
        deleting: "Eliminando relación...",
        deleted: "Relación eliminada exitosamente",
        error_deleting: "Error al eliminar la relación",
        error_deleting_relation: "Error al eliminar la relación del agente",
        modal_title: "Relaciones de Agentes",
        modal_select: "Seleccionar",
        modal_no_relations: "No se encontraron agentes relacionados",
        modal_loading: "Cargando agentes relacionados...",
       
      },
       my_purchased_agents: "Mis Agentes Adquiridos",
       my_purchased_agents_page: {
        title: "Mis Agentes Adquiridos",
        loading: "Cargando...",
        error_loading: "Error al cargar los agentes",
        try_again_later: "Por favor, intenta de nuevo más tarde",
        loading_more: "Cargando más...",
        no_more_agents: "No hay más agentes",
        no_agents_found: "No se encontraron agentes comprados",
        try_later_or_buy: "Intenta más tarde o compra un agente",
       },
       agent_dashboard: {
        title: "Administración de Agentes",
        stats_tab: "Estadística",
        users_tab: "Usuarios",
        invoices_tab: "Facturas",
        add_user: "Agregar Usuario",
        download_code: "Descargar Código",
        go_to_dashboard: "Ir al dashboard",
        go_to_app: "Ir a la app",
        download_modal: {
          title: "Descargar Código",
          subtitle: "Demo HTML del agente de entrevistas",
          api_key_required: "Importante: API Key Requerido",
          api_key_points: {
            point1: "Necesitarás un API Key para usar el agente",
            point2: "Crea un usuario primero para obtener tu API Key",
            point3: "El HTML descargado incluye un campo para ingresar el API Key",
            point4: "Es solo una demostración de cómo se vería integrado"
          },
          what_includes: "¿Qué incluye el archivo?",
          what_includes_desc: "HTML completamente funcional con simulación del agente, estilos integrados y ejemplo de integración.",
          cancel: "Cancelar",
          download_now: "Descargar Ahora"
        },
        carousel: {
          welcome_title: "Te llevaremos de cero a tener un agente funcional en pocos pasos",
          welcome_description: "Con la compra ya realizada, el siguiente paso es crear un usuario. Así obtendrás tu API Key, indispensable para empezar.",
          welcome_bubble: "Hola Bienvenido",
          ready_title: "Ahora que ya tienes el Api Key",
          ready_description: "Introduce el Api Key donde te lo solicitamos y puedes descargar un ejemplo del código",
          ready_bubble: "¡Casi estás listo!",
          done_title: "Listo ya generamos el código",
          done_description: "Ahora puedes descargarlo para poder usarlo",
          done_bubble: "ya puedes usarlo",
          download_button: "Descarga el código aquí"
        },
        stats_title: "Estadísticas del agente",
        stats_desc: "Estadísticas de uso por usuario.",
        bar_chart: "Gráfico de barras",
        pie_chart: "Gráfico de pastel",
        loading_stats: "Cargando estadísticas...",
        loading_wait: "Por favor espera un momento",
        loading_table: "Cargando datos de la tabla...",
        error_title: "Error al cargar datos",
        error_desc: "Hubo un problema al cargar las estadísticas. Por favor intenta más tarde.",
        error_table: "Error al cargar los datos de la tabla. Por favor intenta de nuevo.",
        no_data: "No hay datos disponibles",
        no_results: "No se encontraron resultados para tu búsqueda",
        no_chart_data_title: "Sin Estadísticas Disponibles",
        no_chart_data_desc: "Aún no hay estadísticas de uso para mostrar de este agente.",
        search_placeholder: "Buscar por nombre, correo o usuario...",
        search_button: "Buscar",
        page: "Página",
        previous: "Anterior",
        next: "Siguiente",
        table_api_name: "Nombre API",
        table_user_name: "Nombre Usuario",
        table_name: "Nombre",
        table_email: "Correo",
        table_usage: "Uso",
      },
      users_crud_table: {
        title: "Usuarios",
        create_user: "Crear Usuario",
        edit_user: "Editar Usuario",
        no_users: "No hay usuarios",
        page: "Página",
        of: "de",
        first_name: "Nombre",
        last_name: "Apellido",
        name: "Nombres",
        surname: "Apellido",
        email: "Correo",
        email_address: "Correo Electrónico",
        actions: "Acciones",
        edit: "Editar",
        delete: "Eliminar",
        save: "Guardar",
        cancel: "Cancelar",
        confirm_delete_title: "¿Eliminar usuario?",
        confirm_delete_desc: "¿Estás seguro que deseas eliminar este usuario?",
        confirm_delete: "Eliminar",
        placeholder_name: "Nombre",
        placeholder_surname: "Apellido",
        placeholder_email: "Correo",
        placeholder_email_full: "usuario@empresa.com",
        previous: "Anterior",
        next: "Siguiente",
        api_key: "Clave API",
        api_key_hidden: "Oculta",
        api_key_placeholder: "Clave API",
        toast_user_created: "¡Usuario creado exitosamente!",
        toast_user_updated: "¡Usuario actualizado exitosamente!",
        toast_user_deleted: "¡Usuario eliminado exitosamente!",
        alert_api_key_title: "Esta es tu clave API",
        alert_api_key_desc: "Guarda esta clave API en un lugar seguro. No podrás verla nuevamente.",
        alert_api_key_copy: "Copiar",
        alert_api_key_copied: "¡Copiada!",
        alert_api_key_save_message: "Asegúrate de guardar tu clave API. La necesitarás para acceder a la API.",
        alert_api_key_accept: "Aceptar",
        search_placeholder: "Buscar por nombre, apellido o email...",
        search_button: "Buscar",
        security_notice: "Aviso de Seguridad",
        security_notice_desc: "Se generará una clave API automáticamente. Guárdala en un lugar seguro ya que no se mostrará de nuevo.",
        generate_credentials: "Generar credenciales de API para acceso al agente",
        done: "Listo",
        api_key_generated: "Clave API Generada Exitosamente",
        api_key_ready: "Tus credenciales de autenticación están listas",
        generated_api_key: "Clave API Generada",
      },
      // Modal de éxito de compra
      purchase_success_modal: {
        title: "Compra Realizada con Éxito",
        thank_you: "Gracias por adquirir",
        default_agent: "Entrevistador de IA",
        subtitle: "¡Prepárate para transformar tus entrevistas!",
        benefits: {
          immediate_access: "Acceso inmediato al agente y sus capacidades.",
          priority_support: "Soporte prioritario según el plan elegido.",
          subscription_management: "Gestión de suscripciones y facturación en tu panel."
        },
        close: "Cerrar",
        view_invoice: "Ver Factura",
        start_using: "Empezar a usar el Agente"
      },
      terms_modal: {
        title: "Términos y Condiciones de Uso y Política de Protección de Datos Personales",
        version_label: "Versión {{version}}",
        default_content: "Por favor revisa los términos y condiciones proporcionados por KAIman.",
        accept_checkbox: "He leído y acepto los términos y condiciones.",
        accept_button: "Aceptar términos",
        success_message: "Términos y condiciones aceptados correctamente.",
        error_message: "No pudimos registrar tu aceptación. Intenta nuevamente."
      },
      invoices: {
        page_title: "Mi suscripción",
        page_subtitle: "Gestiona y descarga todas tus facturas de compras",
        list: {
          billing_loading: "Validando datos de facturación...",
          billing_error_title: "No pudimos validar tus datos de facturación",
          billing_error_subtitle: "Intenta nuevamente en unos segundos",
          billing_retry: "Reintentar",
          billing_missing_title: "Completa tus datos de facturación",
          billing_missing_description:
            "Para descargar e imprimir facturas primero necesitamos tus datos fiscales.",
          billing_missing_button: "Ingresar datos de facturación",
          fetch_loading: "Cargando facturas...",
          fetch_error_title: "Error al cargar las facturas",
          fetch_error_subtitle: "Por favor, intenta de nuevo más tarde",
          fetch_retry: "Reintentar",
          empty_title: "No se encontraron facturas",
          empty_subtitle: "Las facturas aparecerán aquí después de realizar compras",
          title: "Mis Facturas",
          refresh: "Actualizar",
          manage_billing: "Datos de facturación",
          table: {
            date: "Fecha",
            amount: "Monto",
            status: "Estado",
            actions: "Acciones",
          },
        },
        billing_data: {
          form_title_create: "Ingresa la información de facturación",
          form_title_edit: "Edita la información de facturación",
          form_subtitle:
            "Completa tu información fiscal para acceder a la descarga de facturas",
          type_client: "Tipo de cliente",
          type_client_person: "Persona Natural",
          type_client_company: "Empresa",
          document_type: "Tipo de documento",
          document_number: "Número de documento",
          company_name: "Razón social",
          names: "Nombres",
          surnames: "Apellidos",
          mail: "Correo electrónico",
          phone: "Teléfono",
          address: "Dirección",
          submit: "Guardar",
          cancel: "Volver",
          saving: "Guardando...",
          success_create: "Datos de facturación guardados",
          success_update: "Datos de facturación actualizados",
          error_submit: "No pudimos guardar los datos. Intenta nuevamente",
          loading: "Cargando datos de facturación...",
          validation_names_required: "Los nombres son obligatorios",
          validation_surnames_required: "Los apellidos son obligatorios",
          validation_company_required: "La razón social es obligatoria",
          validation_document_invalid: "Número de documento inválido",
          validation_phone_invalid: "Solo se permiten números",
          validation_address_invalid: "Máximo 250 caracteres",
          description: "Algunos campos cambian según el tipo de cliente.",
          goto_invoices: "Volver a facturas",
        },
      },
      invoice: {
        billing_data_error: "No pudimos validar tus datos de facturación",
        billing_data_retry: "Reintentar",
        download: "Descargar factura",
        view_details: "Ver detalles",
        status: {
          completed: "Completado",
          success: "Exitoso",
          pending: "Pendiente",
          failed: "Fallido"
        },
        details: {
          title: "Detalles de Factura",
          payment_id: "ID de Pago",
          amount: "Monto",
          date: "Fecha",
          status: "Estado",
          download: "Descargar Factura",
          close: "Cerrar"
        }
      },
      terms_of_use: {
        last_updated: "Última actualización: Marzo 2026",
        section1_title: "Aceptación de los Términos",
        section2_title: "Descripción del Servicio",
        section3_title: "Uso Aceptable",
        section4_title: "Propiedad Intelectual",
        section5_title: "Privacidad y Datos Personales",
        section6_title: "Limitación de Responsabilidad",
        section7_title: "Modificaciones",
        section8_title: "Contacto"
      },
      subscription: {
        free_plan_already_claimed: "Ya has reclamado el plan gratuito",
        next_billing: {
          locale: "es-ES",
          unavailable: "No disponible",
        },
        status: {
          unknown: "Sin información",
          active: "Activa",
          pending_cancel: "Pendiente de cancelación",
          cancelled: "Cancelada",
          label: "Estado",
        },
        view_invoices: "Mi suscripción",
        reactivate: "Reactivar",
        reactivate_success: "Suscripción reactivada exitosamente",
        reactivate_error: "Error al reactivar suscripción",
        grace_period: {
          title: "Acceso hasta el final del período",
          message: "Puedes seguir usando el agente hasta",
        },
        cancel_success: "Tu suscripción fue cancelada exitosamente",
        cancel_error: "Ocurrió un error al cancelar tu suscripción",
        cancel_missing_client: "No pudimos identificar la suscripción a cancelar",
        cancel_reason_required: "Selecciona o ingresa un motivo",
        cancel_reason: {
          too_expensive: "Demasiado costoso",
          not_using: "Ya no lo utilizo con frecuencia",
          missing_features: "Necesito funcionalidades adicionales",
          alternative: "Encontré una alternativa mejor",
          other: "Otro",
        },
        details: {
          title: "Detalles de tu suscripción",
          subtitle: "Consulta el estado de tu plan y gestiona la suscripción",
          agent_missing: "Selecciona un agente para ver su suscripción",
          no_agent_selected:
            "Visita la página de tus agentes comprados y abre la suscripción del agente que deseas revisar.",
          error_loading:
            "No pudimos obtener la información de tu suscripción. Intenta nuevamente más tarde.",
          no_subscription: "No encontramos una suscripción activa para este agente.",
          plan: "Plan actual",
          free_plan: "Plan gratuito",
          unnamed_plan: "Plan personalizado",
          status: "Estado",
          next_renewal: "Próxima renovación",
          cancel_at_period_end: "La suscripción finalizará al término del período actual",
          expired: "Tu período de suscripción ha concluido",
          manage_message:
            "Puedes cancelar tu plan en cualquier momento. Tus accesos se mantendrán hasta el final del período facturado.",
          cancelling: "Cancelando...",
          cancel_button: "Cancelar suscripción",
          refresh_invoices: "Actualizar facturas",
        },
        cancel_modal: {
          title: "Cancelar suscripción",
          description:
            "Cuéntanos por qué deseas cancelar. Esta información nos ayuda a mejorar.",
          question: "¿Cuál es el principal motivo de la cancelación?",
          other_placeholder: "Cuéntanos un poco más",
          other_input_placeholder: "Escribe aquí tu motivo",
          keep: "Mantener suscripción",
          confirming: "Confirmando...",
          confirm: "Confirmar cancelación",
        },
      },
      // Landing page marketing
      landing: {
        hero_title: "Agentes de IA que trabajan por ti mientras tú escalas",
        hero_title_pre1: "Agentes de IA que",
        hero_title_hl1: "trabajan",
        hero_title_pre2: "por ti mientras tú",
        hero_title_hl2: "escalas",
        hero_subtitle: "Multiplica la productividad de tu equipo con agentes especializados que resuelven, analizan, estiman y escalan.",
        hero_cta: "Solicitar Demo",
        metrics: {
          interactions: "Interacciones procesadas",
          companies: "Empresas activas",
          uptime: "Disponibilidad garantizada",
          satisfaction: "Satisfacción del cliente"
        },
        pain_title: "Tu equipo está quemando tiempo en tareas que una IA puede hacer mejor",
        pain_title_pre: "Tu equipo",
        pain_title_hl: "está quemando tiempo",
        pain_title_post: "en tareas que una IA puede hacer mejor",
        pain_subtitle: "Mientras tu competencia automatiza, tú sigues pagando horas-hombre por trabajo repetitivo.",
        pain_1_title: "72% del tiempo perdido",
        pain_1_subtitle: "en tareas administrativas y repetitivas que no generan valor.",
        pain_2_title: "Tickets sin resolver",
        pain_2_subtitle: "acumulándose porque tu equipo de soporte está saturado.",
        pain_3_title: "Proyectos desviados",
        pain_3_subtitle: "por estimaciones incorrectas que destruyen márgenes.",
        steps_title: "Agentes especializados que trabajan 24/7 por una fracción del costo",
        steps_title_pre: "Agentes especializados que trabajan",
        steps_title_hl: "24/7",
        steps_title_post: "por una fracción del costo",
        steps_subtitle: "Pagas por valor entregado: interacciones completadas y problemas resueltos.",
        step_1_title: "Elige tus agentes",
        step_1_desc: "Selecciona los agentes que necesita tu negocio",
        step_2_title: "Integra en minutos",
        step_2_desc: "Conecta con tus herramientas existentes",
        step_3_title: "Escala sin límites",
        step_3_desc: "Paga por las interacciones que consumes",
        agents_title: "Nuestro Agente",
        agents_subtitle: "Conoce a tu nuevo equipo de élite",
        agents_desc: "Un agente especializado. Un solo objetivo: Multiplicar tu productividad",
        resolve: {
          name: "KAIMAN CX Agent",
          tagline: "Soporte que resuelve. Sin excusas.",
          metric: "85% de tickets resueltos automáticamente",
          description: "Tu escudo de primera línea para soporte técnico y atención al cliente. Resuelve tickets en segundos, no en días.",
          feature_1: "Resolución automática de tickets",
          feature_2: "Escalamiento inteligente",
          feature_3: "Respuestas contextuales 24/7",
          feature_4: "Integración con CRMs",
          cta: "Probar CX Agent"
        },
        talent_scout: {
          name: "KAIMAN TALENTIA",
          tagline: "Encuentra diamantes. Descarta piedras.",
          metric: "70% reducción en tiempo de contratación",
          description: "Tu cazatalentos incansable que analiza CVs, evalúa candidatos y predice el fit cultural con precisión quirúrgica.",
          feature_1: "Screening automático de CVs",
          feature_2: "Evaluación de competencias",
          feature_3: "Predicción de rotación",
          feature_4: "Compatibilidad cultural IA",
          cta: "Probar Talentia"
        },
        sprint: {
          name: "KAIMAN SCRIPTIA",
          tagline: "User Stories perfectas. Sprints exitosos.",
          metric: "3x más rápido en refinamiento",
          description: "Acelera tu SDLC con historias de usuario impecables. Estructura, criterios de aceptación y estimaciones en segundos.",
          feature_1: "Generación de User Stories",
          feature_2: "Criterios de aceptación automáticos",
          feature_3: "Integración con Jira/Azure DevOps",
          feature_4: "Estimación inteligente",
          cta: "Probar Scriptia"
        },
        forecast: {
          name: "KAIMAN QUANTIA",
          tagline: "Presupuestos que se cumplen. Proyectos que entregan.",
          metric: "92% de precisión en estimaciones",
          description: "El arquitecto de estimaciones que elimina la incertidumbre. Predicciones basadas en datos históricos y complejidad real.",
          feature_1: "Estimaciones basadas en históricos",
          feature_2: "Análisis de complejidad técnica",
          feature_3: "Roadmaps automáticos",
          feature_4: "Alertas de desviación",
          cta: "Probar Quantia"
        },
        read_more: "Leer más",
        final_cta_title: "¿Listo para multiplicar la productividad de tu equipo?",
        final_cta_subtitle: "Únete a las más de 500 empresas que ya están escalando con KAIMAN.",
        final_cta_button: "Comienza gratis hoy"
      },
      agent_form: {
        required: "(Requerido)",
        required_max_chars: "(Requerido, máx {{max}} caracteres)",
        min_max_range: "(Mín: {{min}}, Máx: {{max}})",
        close: "Cerrar",
        go_back: "Regresar",
        updating: "Actualizando...",
        creating: "Creando...",
        saving: "Guardando...",
        deleting_dots: "Eliminando...",
        edit_agent: "Editar Agente",
        add_agent: "Agregar Agente",
        agent_section: "Agente",
        name_label: "Nombre*",
        name_placeholder: "Nombre del agente",
        description_label: "Descripción*",
        description_placeholder: "Descripción del agente",
        description_required: "La descripción es requerida",
        description_max_length: "La descripción no puede exceder 130 caracteres",
        agent_type: "Tipo de Agente",
        application: "Aplicación",
        logo_label: "Logo*",
        using_defaults: "Usando valores predeterminados",
        loading_settings: "Cargando configuración...",
        error_loading_settings: "Error al cargar la configuración de archivos. Usando valores predeterminados.",
        logo_preview: "Vista previa del logo",
        loading_file_settings: "Cargando configuración de archivos...",
        using_default_settings: "Usando configuración predeterminada",
        invalid_file_type: "Tipo de archivo no válido. Tipos permitidos: {{types}}",
        file_too_large: "El archivo es demasiado grande. Tamaño máximo: {{size}}",
        labels_label: "Etiquetas*",
        max_labels_reached: "Máximo de etiquetas alcanzado",
        search_create_labels: "Buscar o crear nuevas etiquetas...",
        searching_labels: "Buscando etiquetas...",
        creating_label: "Creando \"{{term}}\"...",
        create_label: "Crear \"{{term}}\"",
        no_labels_found: "No se encontraron etiquetas",
        max_labels_limit: "Límite máximo de etiquetas alcanzado",
        max_labels_desc: "Solo puedes agregar hasta {{max}} etiquetas por agente.",
        min_labels_required: "Mínimo de etiquetas requerido",
        min_labels_desc: "Necesitas al menos {{min}} etiqueta(s) por agente.",
        max_labels_exceeded: "Máximo de etiquetas excedido",
        description_too_long: "Descripción demasiado larga",
        description_too_long_desc: "La descripción no puede exceder {{max}} caracteres. Actual: {{current}}",
        about_too_long: "Acerca de demasiado largo",
        about_too_long_desc: "Acerca de no puede exceder {{max}} caracteres. Actual: {{current}}",
        country: "País:",
        select_country: "Seleccionar país",
        no_countries_available: "No hay países disponibles",
        state_province: "Estado / Provincia*",
        select_state: "Seleccionar estado",
        select_country_first: "Selecciona un país primero",
        city: "Ciudad*",
        select_city: "Seleccionar ciudad",
        select_state_first: "Selecciona un estado primero",
        principal_street: "Calle principal*",
        number: "Número*",
        secondary_street: "Calle secundaria*",
        zip_code: "Código postal*",
        reference: "Referencia:",
        failed_load_countries: "Error al cargar países",
        error_loading_countries: "Hubo un error al cargar la lista de países. Por favor intenta de nuevo.",
        failed_load_states: "Error al cargar estados",
        error_loading_states: "Hubo un error al cargar la lista de estados. Por favor intenta de nuevo.",
        failed_load_cities: "Error al cargar ciudades",
        error_loading_cities: "Hubo un error al cargar la lista de ciudades. Por favor intenta de nuevo.",
        agent_updated: "Agente actualizado",
        agent_updated_desc: "Tu agente ha sido actualizado exitosamente.",
        failed_update_agent: "Error al actualizar agente",
        error_updating_agent: "Hubo un error al actualizar tu agente. Por favor intenta de nuevo.",
        agent_created: "Agente creado",
        agent_created_desc: "Tu agente ha sido creado exitosamente y ya está disponible.",
        failed_create_agent: "Error al crear agente",
        error_creating_agent: "Hubo un error al crear tu agente. Por favor intenta de nuevo.",
        author_section: "Autor",
        brand_name: "Nombre de marca*",
        brand_name_placeholder: "Nombre de marca",
        full_name: "Nombre completo*",
        full_name_placeholder: "Nombre completo",
        about_label: "Acerca de*",
        about_placeholder: "Acerca del autor",
        about_required: "Acerca de es requerido",
        about_max_length: "Acerca de no puede exceder 130 caracteres",
        edit_tab: "Editar {{tab}}",
        add_tab: "Agregar {{tab}}",
        edit_description: "Editar Descripción",
        add_description: "Agregar Descripción",
        media_label: "Multimedia:",
        details_label: "Detalles:",
        description_is_required: "La descripción es requerida",
        image_is_required: "La imagen es requerida",
        or_drag_file: "o arrastra un archivo aquí",
        description_updated: "Descripción actualizada",
        description_updated_desc: "Tu descripción ha sido actualizada exitosamente.",
        description_created: "Descripción creada",
        description_created_desc: "Tu descripción ha sido creada exitosamente y ya está disponible.",
        failed_create_description: "Error al crear descripción",
        error_creating_description: "Hubo un error al crear tu descripción. Por favor intenta de nuevo.",
        search_agent: "Buscar agente...",
        select_relation: "Seleccione relación",
        select_relation_first: "Primero selecciona un tipo de relación",
        add_button: "Agregar",
        delete_relation_title: "Eliminar relación",
        delete_relation_desc: "¿Seguro que deseas eliminar la relación de este agente?",
        delete_button: "Eliminar",
      },
      plan_stepper: {
        trial_label: "Prueba",
        trial_price: "Gratis",
        trial_duration: "7 días",
        trial_description: "Prueba gratuita",
        trial_feature_1: "Acceso limitado",
        trial_feature_2: "10 consultas máximo",
        basic_label: "Básico",
        basic_duration: "/mes",
        basic_description: "Plan básico",
        basic_feature_1: "100 consultas/mes",
        basic_feature_2: "Soporte por email",
        normal_label: "Normal",
        normal_duration: "/mes",
        normal_description: "Plan estándar",
        normal_feature_1: "500 consultas/mes",
        normal_feature_2: "Soporte prioritario",
        normal_feature_3: "Análisis básico",
        premium_label: "Premium",
        premium_duration: "/mes",
        premium_description: "Plan completo",
        premium_feature_1: "Consultas ilimitadas",
        premium_feature_2: "Soporte 24/7",
        premium_feature_3: "Análisis avanzado",
        free_label: "Gratis",
        free_price: "Gratis",
        free_duration: "Siempre",
        free_description: "Plan gratuito",
        free_feature_1: "Acceso básico",
        free_feature_2: "Soporte comunitario",
        processing: "Procesando...",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
